
// import { useEffect, useState } from "react";
// import axios from "axios";
// import { useLocation, useNavigate } from "react-router-dom";
// import {
//   Box,
//   Button,
//   Card,
//   CardContent,
//   CircularProgress,
//   Container,
//   Grid,
//   IconButton,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TextField,
//   Typography,
//   Chip,
//   useTheme,
//   useMediaQuery,
//   Avatar,
//   Badge,
//   Divider,
//   Snackbar,
//   Alert,
//   InputAdornment,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
// } from "@mui/material";
// import {
//   DateRange as DateRangeIcon,
//   AccessTime as TimeIcon,
//   Person as PersonIcon,
//   Phone as PhoneIcon,
//   Add as AddIcon,
//   CheckCircle as CheckCircleIcon,
//   Pending as PendingIcon,
//   Search as SearchIcon,
//   Refresh as RefreshIcon,
//   Close as CloseIcon,
//   Print as PrintIcon,
//   ReceiptLong,
// } from "@mui/icons-material";

// // QZ Tray imports
// import qz from "qz-tray";

// // Thermal printer configuration
// const PRINTER_NAME = "BIXOLON SRP-E302"; // Change to your thermal printer name

// // Enhanced Cash drawer commands for thermal printers
// const CASH_DRAWER_COMMANDS = {
//   OPEN_DRAWER_PIN2: "\x1B\x70\x00\x19\xFA",
//   OPEN_DRAWER_PIN5: "\x1B\x70\x01\x19\xFA",
//   ALTERNATE_1: "\x1B\x70\x00\x60\x60",
//   ALTERNATE_2: "\x1B\x70\x01\x60\x60",
//   BELL_COMMAND: "\x07",
// };

// // QZ Tray Thermal Printing Component for Appointments
// const QZTrayAppointmentPrint = ({ 
//   open, 
//   onClose, 
//   appointment 
// }) => {
//   const [printStatus, setPrintStatus] = useState({ open: false, message: '', severity: 'info' });
//   const [isPrinting, setIsPrinting] = useState(false);

//   const showMessage = (message, severity = 'info') => {
//     setPrintStatus({ open: true, message, severity });
//   };

//   // Thermal printer formatting constants
//   const esc = "\x1B";
//   const gs = "\x1D";
//   const LINE_WIDTH = 48; // 80mm thermal printer width

//   const leftRight = (left, right, width = LINE_WIDTH) => {
//     const space = width - (left.length + right.length);
//     return left + " ".repeat(space > 0 ? space : 1) + right;
//   };

//   const centerText = (text, width = LINE_WIDTH) => {
//     const padding = Math.max(0, Math.floor((width - text.length) / 2));
//     return " ".repeat(padding) + text;
//   };

//   const divider = (char = "-") => char.repeat(LINE_WIDTH) + "\n";

//   const formatTime = (timeString) => {
//     return new Date(`1970-01-01T${timeString}`).toLocaleTimeString("en-LK", {
//       hour: "numeric",
//       minute: "numeric",
//       hour12: true,
//     });
//   };

//   // Generate thermal appointment receipt commands for QZ Tray
//   const generateAppointmentReceipt = () => {
//     const currentDate = new Date().toLocaleDateString('en-LK');
//     const currentTime = new Date().toLocaleTimeString('en-LK', { 
//       hour: '2-digit', 
//       minute: '2-digit',
//       hour12: false 
//     });

//     const lines = [
//       esc + "@", // Initialize printer
      
//       // Company header - Center aligned and emphasized
//       esc + "a" + "\x01", // Center align
//       esc + "!" + "\x38", // Double height and emphasized
//       "AURA MEDITATION CENTER\n",
//       esc + "!" + "\x00", // Cancel text formatting
      
  
      
//       divider("="),
      
//       // Receipt title
//       esc + "!" + "\x12", // Medium size
//       esc + "a" + "\x01", // Center align
//       esc + "!" + "\x28", // Double height and emphasized
//       "APPOINTMENT CONFIRMATION\n",
//       esc + "!" + "\x00", // Cancel size
//       divider("="),
      
     
      
//       // Channel Number - Large and emphasized
//       esc + "a" + "\x01", // Center align
//       esc + "!" + "\x38", // Double height and emphasized
//       "CHANNEL NUMBER\n",
//       esc + "!" + "\x38", // Double height and emphasized
//       `${appointment?.MAD_PATIENT_NO || 'N/A'}\n`,
//       esc + "!" + "\x00", // Cancel size
      
//       divider("="),
      
//       // Important notice
//       esc + "a" + "\x01", // Center align
//       esc + "!" + "\x08", // Emphasized
//       "ARRIVE 15 MINUTES EARLY\n",
//       esc + "!" + "\x00", // Cancel emphasis
      
//       // "\n",
//       // centerText("THANK YOU!") + "\n",
//       // centerText("Aura Meditation Center") + "\n",
//       // "\n",
//       divider("*"),
//       centerText("Generated: " + new Date().toLocaleString('en-LK')) + "\n",
//       "\n\n\n\n\n", // Extra lines for paper cut
//       gs + "V" + "\x41" + "\x03" // Cut paper
//     ];

//     return lines.join("");
//   };

//   const printThermalReceipt = async () => {
//     if (isPrinting) return;
    
//     setIsPrinting(true);
    
//     try {
//       // Connect to printer first
//       if (!qz.websocket.isActive()) {
//         await qz.websocket.connect();
//       }
//       const config = qz.configs.create(PRINTER_NAME);

//       const printData = generateAppointmentReceipt();

//       // Print the receipt
//       console.log("Printing thermal appointment receipt...");
//       await qz.print(config, [{ type: "raw", format: "command", data: printData }]);
//       console.log("Thermal appointment receipt printed successfully");

//       showMessage('Appointment receipt printed successfully!', 'success');
//       onClose();
//     } catch (err) {
//       console.error("Print process failed:", err);
//       showMessage("Print error: " + err.message, 'error');
//     } finally {
//       setIsPrinting(false);
//     }
//   };

//   return (
//     <>
//       <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
//         <DialogTitle>
//           <Box display="flex" alignItems="center" gap={1}>
//             <ReceiptLong color="primary" />
//             QZ Tray Thermal Printing - Appointment
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//             Direct printing to thermal printer using QZ Tray
//           </Typography>
          
//           <Card variant="outlined" sx={{ mb: 3 }}>
//             <CardContent>
//               <Typography variant="h6" gutterBottom>
//                 Appointment Receipt Preview (Thermal Format)
//               </Typography>
//               <Paper 
//                 variant="outlined" 
//                 sx={{ 
//                   p: 2, 
//                   backgroundColor: '#f5f5f5', 
//                   fontFamily: 'Courier New, monospace', 
//                   fontSize: '12px', 
//                   lineHeight: '1.2', 
//                   whiteSpace: 'pre',
//                   maxHeight: '400px',
//                   overflow: 'auto',
//                   border: '1px dashed #ccc'
//                 }}
//               >
//                 {generateAppointmentReceipt().replace(/\x1B\[.*?m/g, '')} {/* Remove escape sequences for preview */}
//               </Paper>
//             </CardContent>
//           </Card>

//           <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
//             <Typography variant="body2" color="text.secondary">
//               Printer: {PRINTER_NAME}
//             </Typography>
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={onClose}>Cancel</Button>
//           <Button 
//             onClick={printThermalReceipt} 
//             variant="contained" 
//             color="primary"
//             startIcon={<PrintIcon />}
//             disabled={isPrinting}
//           >
//             {isPrinting ? "Printing..." : "Print Thermal Receipt"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar 
//         open={printStatus.open} 
//         autoHideDuration={6000} 
//         onClose={() => setPrintStatus({ ...printStatus, open: false })}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert 
//           severity={printStatus.severity} 
//           onClose={() => setPrintStatus({ ...printStatus, open: false })}
//         >
//           {printStatus.message}
//         </Alert>
//       </Snackbar>
//     </>
//   );
// };

// export default function DailyAppointment() {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const navigate = useNavigate();

//   const [timeslots, setTimeslots] = useState([]);
//   const [error, setError] = useState(null);
//   const [appointments, setAppointments] = useState([]);
//   const [selectedSlotId, setSelectedSlotId] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const Name = localStorage.getItem("Name");
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("info");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [qzTrayDialogOpen, setQzTrayDialogOpen] = useState(false);
//   const [selectedAppointment, setSelectedAppointment] = useState(null);
//   const [selectedDate, setSelectedDate] = useState(() => {
//     const now = new Date();
//     const year = now.getFullYear();
//     const month = String(now.getMonth() + 1).padStart(2, '0');
//     const day = String(now.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   });

//   const showSnackbar = (message, severity = "info") => {
//     setSnackbarMessage(message);
//     setSnackbarSeverity(severity);
//     setSnackbarOpen(true);
//   };

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   useEffect(() => {
//     const fetchTimeslotsByDate = async () => {
//       setIsLoading(true);
//       try {
//         // Using the specific API endpoint you requested
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_BASE_URL}/Timeslot/active-timeslots?date=${selectedDate}`
//         );
//         setTimeslots(response.data);
//         setError(null);
//         showSnackbar(`Loaded timeslots for ${selectedDate}`, "success");
//       } catch (error) {
//         setTimeslots([]);
//         setError("No timeslots available for the selected date.");
//         showSnackbar("No timeslots found for selected date", "warning");
//         console.error("Error fetching timeslots:", error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     if (selectedDate) {
//       fetchTimeslotsByDate();
//     }
//   }, [selectedDate]);

//   const handleViewAppointments = async (slotId) => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/appointments/${slotId}`
//       );
//       setAppointments(response.data);
//       setSelectedSlotId(slotId);
//       setIsModalOpen(true);
      
//     } catch (error) {
//       console.error("Error fetching appointments:", error);
//       showSnackbar("No appointments available for this timeslot", "info");
//       setAppointments([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//   };

//   const handleStatusUpdate = async (appointment) => {
//     try {
//       // Use the correct property names from the appointment object
//       const patientCode = appointment.MAD_PATIENT_CODE;
//       const appointmentID = appointment.MAD_APPOINMENT_ID;
      
//       const date = selectedDate; // using the date from your component state
      
//       console.log('Updating status with:', { patientCode, appointmentID, date });  
//       const response = await axios.put(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/status/${appointmentID}`,
//         JSON.stringify("c"), 
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       if (response.status === 200) {
//         console.log('Status updated successfully');
//         showSnackbar("Status updated to completed", "success");
        
//         // Refresh the appointments data
//         if (selectedSlotId) {
//           handleViewAppointments(selectedSlotId);
//         }
//       }
//     } catch (error) {
//       console.error('Error updating status:', error);
//       showSnackbar("Failed to update status", "error");
//     }
//   };

//   const handleAddRecord = (patientId, appointmentID, patientNo) => {
//     navigate(`/dashboard/addrecord/${patientId}`, {
//       state: { appointmentid: appointmentID, channelnumber: patientNo, MTD_APPOINMENT_ID: appointmentID },
//     });
//   };

//   const handlePrintAppointment = (appointmentId, patientCode, patientName, allocatedTime, patientNo) => {
//     // Create a print window
//     const printWindow = window.open('', '_blank');
    
//     const formattedTime = formatTime(allocatedTime);
//     const currentDate = new Date().toLocaleDateString('en-LK');
//     const currentTime = new Date().toLocaleTimeString('en-LK', { 
//       hour: '2-digit', 
//       minute: '2-digit',
//       hour12: false 
//     });

//     printWindow.document.write(`
//       <html>
//         <head>
//           <title>Appointment Details - ${appointmentId}</title>
//           <style>
//             * {
//               margin: 0;
//               padding: 0;
//               box-sizing: border-box;
//             }
            
//             body { 
//               font-family: Arial, sans-serif; 
//               margin: 0;
//               padding: 5px;
//               background: #ffffff;
//               color: #000000;
//               line-height: 1.2;
//               font-size: 10px;
//             }
            
//             .print-container {
//               width: 100%;
//               max-width: 200px;
//               margin: 0 auto;
//               border: 1px solid #000000;
//               border-radius: 3px;
//               padding: 8px;
//               background: #ffffff;
//             }
            
//             .header {
//               text-align: center;
//               margin-bottom: 8px;
//               padding-bottom: 5px;
//               border-bottom: 1px solid #000000;
//             }
            
//             .clinic-name {
//               font-size: 21px;
//               font-weight: bold;
//               color: #000000;
//               margin-bottom: 2px;
//             }
            
//             .document-title {
//               font-size: 18px;
//               font-weight: bold;
//               color: #000000;
//             }
            
//             .main-info {
//               margin: 8px 0;
//               padding: 6px;
//               border: 2px solid #000000;
//               border-radius: 3px;
//               background: #ffff00;
//               text-align: center;
//             }
            
//             .info-label {
//               font-size: 18px;
//               font-weight: bold;
//               color: #000000;
//               margin-bottom: 3px;
//             }
            
//             .info-value {
//               font-size: 36px;
//               font-weight: bold;
//               color: #000000;
//               margin: 4px 0;
//             }
            
//             .patient-info {
//               background: #ffffff;
//               padding: 6px;
//               border: 1px solid #000000;
//               border-radius: 2px;
//               margin: 8px 0;
//             }
            
//             .detail-row {
//               display: flex;
//               justify-content: space-between;
//               margin-bottom: 3px;
//               font-size: 18px;
//             }
            
//             .detail-label {
//               font-weight: bold;
//               color: #000000;
//             }
            
//             .detail-value {
//               font-weight: normal;
//               color: #000000;
//               text-align: right;
//             }
            
//             .arrival-notice {
//               background: #000000;
//               color: #ffffff;
//               padding: 6px;
//               border-radius: 4px;
//               margin: 10px 0 0 0;
//               text-align: center;
//               font-weight: bold;
//               font-size: 18px;
//             }
            
//             @media print {
//               body { 
//                 margin: 0;
//                 padding: 3px;
//               }
//               .print-container {
//                 border: 1px solid #000000 !important;
//                 box-shadow: none !important;
//                 margin: 0 !important;
//                 max-width: 100% !important;
//                 transform: scale(0.9);
//               }
//               .no-print { display: none !important; }
//             }
//           </style>
//         </head>
//         <body>
//           <div class="print-container">
//             <div class="header">
//               <div class="clinic-name">Aura Meditation Center</div>
//               <div class="document-title">APPOINTMENT CONFIRMATION</div>
//             </div>
            
//             <div class="main-info">         
//               <div class="info-label">Channel Number</div>
//               <div class="info-value">${patientNo}</div>
//             </div>
            
//             <div class="patient-info">
//               <div class="detail-row">
//                 <span class="detail-label">Name:</span>
//                 <span class="detail-value">${patientName}</span>
//               </div>
//               <div class="detail-row">
//                 <span class="detail-label">Time:</span>
//                 <span class="detail-value">${formattedTime}</span>
//               </div>
//               <div class="detail-row">
//                 <span class="detail-label">Date:</span>
//                 <span class="detail-value">${currentDate}</span>
//               </div>
//             </div>

//             <div class="arrival-notice">
//               ARRIVE 15 MIN EARLY
//             </div>
//           </div>

//           <script>
//             window.onload = function() {
//               window.print();
//               setTimeout(function() {
//                 window.close();
//               }, 500);
//             };
//           </script>
//         </body>
//       </html>
//     `);
//     printWindow.document.close();
    
//     showSnackbar("Opening print preview...", "info");
//   };

//   // New function for QZ Tray thermal printing
//   const handleQZTrayPrint = (appointment) => {
//     setSelectedAppointment(appointment);
//     setQzTrayDialogOpen(true);
//   };

//   const handleDateChange = (e) => {
//     setSelectedDate(e.target.value);
//     setAppointments([]);
//     setSelectedSlotId(null);
//   };

//   const filteredAppointments = appointments.filter((appointment) =>
//     appointment.MAD_FULL_NAME.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const formatTime = (timeString) => {
//     return new Date(`1970-01-01T${timeString}`).toLocaleTimeString("en-LK", {
//       hour: "numeric",
//       minute: "numeric",
//       hour12: true,
//     });
//   };

//   const handleCancelAppointment = async (appointmentId) => {
//     try {
//       setIsLoading(true);
//       await axios.delete(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/cancel-appointment/${appointmentId}`
//       );

//       setAppointments(appointments.map(appt =>
//         appt.MAD_APPOINMENT_ID === appointmentId
//           ? { ...appt, MAD_STATUS: "I" }
//           : appt
//       ));

//       showSnackbar("Appointment cancelled successfully", "success");
//     } catch (error) {
//       console.error("Error cancelling appointment:", error);
//       showSnackbar("Failed to cancel appointment", "error");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <Container maxWidth="xl" sx={{ py: 3 }}>
//       <Paper elevation={3} sx={{ p: 4 }}>
//         <Box
//           sx={{
//             mb: 4,
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//           }}
//         >
//           <Typography
//             variant="h4"
//             component="h1"
//             gutterBottom
//             color="primary"
//             fontWeight={600}
//             align="center"
//           >
//             Daily Appointments
//           </Typography>

        
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: isMobile ? "column" : "row",
//               gap: 2,
//               mb: 3,
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             <TextField
//               type="date"
//               label="Select Date"
//               value={selectedDate}
//               onChange={handleDateChange}
//               InputLabelProps={{ shrink: true }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <DateRangeIcon sx={{ color: "primary.main" }} />
//                   </InputAdornment>
//                 ),
//               }}
//               inputProps={{
//                 placeholder: "YYYY/MM/DD"
//               }}
//               sx={{
//                 minWidth: isMobile ? "100%" : 250,
//                 '& .MuiInputBase-input': {
//                   position: 'relative',
//                   backgroundColor: 'transparent',
//                 },
//                 '& input[type="date"]': {
//                   color: 'transparent',
//                   position: 'relative',
//                   '&::-webkit-calendar-picker-indicator': {
//                     opacity: 0,
//                     position: 'absolute',
//                     left: 0,
//                     top: 0,
//                     width: '100%',
//                     height: '100%',
//                     cursor: 'pointer',
//                     zIndex: 2,
//                   },
//                 },
//                 '& .MuiInputBase-root': {
//                   position: 'relative',
//                   '&::after': {
//                     content: selectedDate
//                       ? `"${selectedDate.split('-').join('/')}"`
//                       : '"YYYY/MM/DD"',
//                     position: 'absolute',
//                     left: '40px',
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     color: selectedDate ? 'rgba(0, 0, 0, 0.87)' : 'rgba(0, 0, 0, 0.6)',
//                     fontSize: '14px',
//                     fontFamily: 'inherit',
//                     pointerEvents: 'none',
//                     zIndex: 1,
//                   }
//                 }
//               }}
//             />
//           </Box>
//         </Box>

//         {isLoading && !selectedSlotId ? (
//           <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//             <CircularProgress />
//           </Box>
//         ) : error ? (
//           <Paper elevation={3} sx={{ p: 3, textAlign: "center" }}>
//             <Typography variant="h6" color="textSecondary">
//               {error}
//             </Typography>
//           </Paper>
//         ) : (
//           <Grid container spacing={3}>
//             <Grid item xs={12}>
//               <Typography
//                 variant="h6"
//                 gutterBottom
//                 color="primary"
//                 fontWeight={600}
//               >
//                 Available Timeslots
//               </Typography>
//               <Grid container spacing={2}>
//                 {timeslots.map((timeslot) => (
//                   <Grid item xs={12} key={timeslot.MT_SLOT_ID}>
//                     <Card
//                       elevation={3}
//                       sx={{
//                         borderLeft:
//                           selectedSlotId === timeslot.MT_SLOT_ID
//                             ? `4px solid ${theme.palette.primary.main}`
//                             : "none",
//                         cursor: "pointer",
//                         "&:hover": {
//                           boxShadow: 4,
//                         },
//                       }}
//                       onClick={() =>
//                         handleViewAppointments(timeslot.MT_SLOT_ID)
//                       }
//                     >
//                       <CardContent>
//                         <Box
//                           sx={{ display: "flex", alignItems: "center", mb: 1 }}
//                         >
//                           <Avatar
//                             sx={{ bgcolor: theme.palette.primary.main, mr: 2 }}
//                           >
//                             <PersonIcon />
//                           </Avatar>
//                           <Typography variant="subtitle1">
//                             {timeslot.MT_DOCTOR}
//                           </Typography>
//                         </Box>
//                         <Box sx={{ display: "flex", alignItems: "center" }}>
//                           <TimeIcon color="action" sx={{ mr: 1 }} />
//                           <Typography>
//                             {formatTime(timeslot.MT_START_TIME)} -{" "}
//                             {formatTime(timeslot.MT_END_TIME)}
//                           </Typography>
//                         </Box>
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 ))}
//               </Grid>
//             </Grid>
//           </Grid>
//         )}

//         <Dialog
//           open={isModalOpen}
//           onClose={handleCloseModal}
//           fullWidth
//           maxWidth="md"
//           fullScreen={isMobile}
//         >
//           <DialogTitle>
//             <Box
//               display="flex"
//               justifyContent="space-between"
//               alignItems="center"
//             >
//               <Typography
//                 variant="h4"
//                 component="h1"
//                 gutterBottom
//                 color="primary"
//                 fontWeight={600}
//                 align="center"
//                 sx={{ mb: -1 }}
//               >
//                 Appointments
//               </Typography>
//               <IconButton onClick={handleCloseModal}>
//                 <CloseIcon />
//               </IconButton>
//             </Box>
//           </DialogTitle>
//           <DialogContent dividers>
//             <Box sx={{ mb: 2 }}>
//               <TextField
//                 size="small"
//                 fullWidth
//                 placeholder="Search patients..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment
//                       position="start"
//                       sx={{ color: "primary.main" }}
//                     >
//                       <SearchIcon />
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Box>

//             {isLoading ? (
//               <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//                 <CircularProgress />
//               </Box>
//             ) : filteredAppointments.length === 0 ? (
//               <Typography
//                 variant="body1"
//                 color="textSecondary"
//                 sx={{ textAlign: "center", py: 4 }}
//               >
//                 No appointments found for this timeslot
//               </Typography>
//             ) : (
//               <TableContainer>
//                 <Table size={isMobile ? "small" : "medium"}>
//                   <TableHead sx={{ backgroundColor: theme.palette.primary.light }}>
//                     <TableRow>
//                       <TableCell sx={{ color: "white", fontWeight: "bold" }}>Patient</TableCell>
//                       <TableCell sx={{ color: "white", fontWeight: "bold" }}>Contact</TableCell>
//                       <TableCell sx={{ color: "white", fontWeight: "bold" }}>Time</TableCell>
//                       <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>No.</TableCell>
//                       <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>Status</TableCell>
//                       <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>Action</TableCell>
//                     </TableRow>
//                   </TableHead>

//                   <TableBody>
//                     {filteredAppointments.map((appointment) => (
//                       <TableRow
//                         key={appointment.MAD_APPOINMENT_ID}
//                         hover
//                         sx={{
//                           opacity: appointment.MAD_STATUS === "I" ? 0.6 : 1,
//                           backgroundColor: appointment.MAD_STATUS === "I" ? '#ffe6e6' : 'inherit'
//                         }}
//                       >
//                         <TableCell>
//                           <Box sx={{ display: "flex", alignItems: "center" }}>
//                             <Avatar sx={{ width: 32, height: 32, mr: 1 }}>
//                               {appointment.MAD_FULL_NAME.charAt(0)}
//                             </Avatar>
//                             {appointment.MAD_FULL_NAME}
//                           </Box>
//                         </TableCell>
//                         <TableCell>{appointment.MAD_CONTACT}</TableCell>
//                         <TableCell>
//                           {formatTime(appointment.MAD_ALLOCATED_TIME)}
//                         </TableCell>
//                         <TableCell align="center">
//                           <Chip
//                             label={appointment.MAD_PATIENT_NO}
//                             color="primary"
//                             size="small"
//                           />
//                         </TableCell>
                       
//                         <TableCell align="center">
//                             {appointment.MAD_STATUS === "I" ? (
//                               <Chip
//                                 label="Cancelled"
//                                 color="error"
//                                 size="small"
//                               />
//                             ) : appointment.MAD_STATUS === "c" ? (
//                                 <Chip
//                                   icon={<CheckCircleIcon fontSize="small" />}
//                                   label="Completed"
//                                   color="success"
//                                   size="small"
//                                 />
//                               ): appointment.TreatmentStatus === "C" ? (
//                               <Chip
//                                 icon={<CheckCircleIcon fontSize="small" />}
//                                 label="Completed"
//                                 color="success"
//                                 size="small"
//                               />
//                             ) : appointment.TreatmentStatus === "P" ? (
//                               <Chip
//                                 icon={<CheckCircleIcon fontSize="small" />}
//                                 label="Preparation Complete"
//                                 color="info"
//                                 size="small"
//                                 clickable
//                                 onClick={() => handleStatusUpdate(appointment)}
//                               />
//                             ) : (
//                               <Chip
//                                 icon={<PendingIcon fontSize="small" />}
//                                 label="Preparation Complete"
//                                 color="warning"
//                                 size="small"
//                                 clickable
//                                 onClick={() => handleStatusUpdate(appointment)}
//                               />
//                             )}
//                           </TableCell>
//                         <TableCell align="center" sx={{ display: 'flex', gap: 1, flexWrap: isMobile ? 'wrap' : 'nowrap' }}>
//                           <Button
//                             variant="outlined"
//                             size="small"
//                             startIcon={<AddIcon />}
//                             onClick={() => {
//                               handleAddRecord(
//                                 appointment.MAD_PATIENT_CODE,
//                                 appointment.MAD_APPOINMENT_ID,
//                                 appointment.MAD_PATIENT_NO
//                               );
//                               handleCloseModal();
//                             }}
//                             disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
//                           >
//                             {isMobile ? "Add" : "Add Treatment"}
//                           </Button>
//                           <Button
//                             variant="outlined"
//                             size="small"
//                             color="error"
//                             startIcon={<CloseIcon />}
//                             onClick={() => handleCancelAppointment(appointment.MAD_APPOINMENT_ID)}
//                             disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
//                           >
//                             {isMobile ? "Cancel" : "Cancel"}
//                           </Button>
                          
//                           <Button
//                             variant="contained"
//                             size="small"
//                             color="secondary"
//                             startIcon={<PrintIcon />}
//                             onClick={() => handleQZTrayPrint(appointment)}
//                           >
//                             {isMobile ? "Appoinment Recipet" : " Appoinment Recipet"}
//                           </Button>
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             )}
//           </DialogContent>
//         </Dialog>

//         {/* QZ Tray Thermal Printing Dialog */}
//         <QZTrayAppointmentPrint
//           open={qzTrayDialogOpen}
//           onClose={() => setQzTrayDialogOpen(false)}
//           appointment={selectedAppointment}
//         />

//         <Snackbar
//           open={snackbarOpen}
//           autoHideDuration={6000}
//           onClose={handleSnackbarClose}
//           anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         >
//           <Alert
//             onClose={handleSnackbarClose}
//             severity={snackbarSeverity}
//             sx={{ width: "100%" }}
//           >
//             {snackbarMessage}
//           </Alert>
//         </Snackbar>
//       </Paper>
//     </Container>
//   );
//  }


////////////////////////////////////////2025-10-21


// import { useEffect, useState } from "react";
// import axios from "axios";
// import { useLocation, useNavigate } from "react-router-dom";
// import {
//   Box,
//   Button,
//   Card,
//   CardContent,
//   CircularProgress,
//   Container,
//   Grid,
//   IconButton,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TextField,
//   Typography,
//   Chip,
//   useTheme,
//   useMediaQuery,
//   Avatar,
//   Badge,
//   Divider,
//   Snackbar,
//   Alert,
//   InputAdornment,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Drawer,
// } from "@mui/material";
// import {
//   DateRange as DateRangeIcon,
//   AccessTime as TimeIcon,
//   Person as PersonIcon,
//   Phone as PhoneIcon,
//   Add as AddIcon,
//   CheckCircle as CheckCircleIcon,
//   Pending as PendingIcon,
//   Search as SearchIcon,
//   Refresh as RefreshIcon,
//   Close as CloseIcon,
//   Print as PrintIcon,
//   ReceiptLong,
// } from "@mui/icons-material";

// // QZ Tray imports
// import qz from "qz-tray";

// // Thermal printer configuration
// const PRINTER_NAME = "BIXOLON SRP-E302"; // Change to your thermal printer name

// // Enhanced Cash drawer commands for thermal printers
// const CASH_DRAWER_COMMANDS = {
//   OPEN_DRAWER_PIN2: "\x1B\x70\x00\x19\xFA",
//   OPEN_DRAWER_PIN5: "\x1B\x70\x01\x19\xFA",
//   ALTERNATE_1: "\x1B\x70\x00\x60\x60",
//   ALTERNATE_2: "\x1B\x70\x01\x60\x60",
//   BELL_COMMAND: "\x07",
// };

// // QZ Tray Thermal Printing Component for Appointments
// const QZTrayAppointmentPrint = ({ 
//   open, 
//   onClose, 
//   appointment 
// }) => {
//   const [printStatus, setPrintStatus] = useState({ open: false, message: '', severity: 'info' });
//   const [isPrinting, setIsPrinting] = useState(false);

//   const showMessage = (message, severity = 'info') => {
//     setPrintStatus({ open: true, message, severity });
//   };

//   // Thermal printer formatting constants
//   const esc = "\x1B";
//   const gs = "\x1D";
//   const LINE_WIDTH = 48; // 80mm thermal printer width

//   const leftRight = (left, right, width = LINE_WIDTH) => {
//     const space = width - (left.length + right.length);
//     return left + " ".repeat(space > 0 ? space : 1) + right;
//   };

//   const centerText = (text, width = LINE_WIDTH) => {
//     const padding = Math.max(0, Math.floor((width - text.length) / 2));
//     return " ".repeat(padding) + text;
//   };

//   const divider = (char = "-") => char.repeat(LINE_WIDTH) + "\n";

//   const formatTime = (timeString) => {
//     return new Date(`1970-01-01T${timeString}`).toLocaleTimeString("en-LK", {
//       hour: "numeric",
//       minute: "numeric",
//       hour12: true,
//     });
//   };

//   // Generate thermal appointment receipt commands for QZ Tray
//   const generateAppointmentReceipt = () => {
//     const currentDate = new Date().toLocaleDateString('en-LK');
//     const currentTime = new Date().toLocaleTimeString('en-LK', { 
//       hour: '2-digit', 
//       minute: '2-digit',
//       hour12: false 
//     });

//     const lines = [
//       esc + "@", // Initialize printer
      
//       // Company header - Center aligned and emphasized
//       esc + "a" + "\x01", // Center align
//       esc + "!" + "\x38", // Double height and emphasized
//       "AURA MEDITATION CENTER\n",
//       esc + "!" + "\x00", // Cancel text formatting
      
  
      
//       divider("="),
      
//       // Receipt title
//       esc + "!" + "\x12", // Medium size
//       esc + "a" + "\x01", // Center align
//       esc + "!" + "\x28", // Double height and emphasized
//       "APPOINTMENT CONFIRMATION\n",
//       esc + "!" + "\x00", // Cancel size
//       divider("="),
      
     
      
//       // Channel Number - Large and emphasized
//       esc + "a" + "\x01", // Center align
//       esc + "!" + "\x38", // Double height and emphasized
//       "CHANNEL NUMBER\n",
//       esc + "!" + "\x38", // Double height and emphasized
//       `${appointment?.MAD_PATIENT_NO || 'N/A'}\n`,
//       esc + "!" + "\x00", // Cancel size

//       esc + "!" + "\x08", // Emphasized normal size
//       `${appointment?.MAD_FULL_NAME || 'N/A'}\n`,
//       esc + "!" + "\x00", // Reset style
      
//       divider("="),
      
//       // Important notice
//       esc + "a" + "\x01", // Center align
//       esc + "!" + "\x08", // Emphasized
//       "ARRIVE 30 MINUTES EARLY\n",
//       esc + "!" + "\x00", // Cancel emphasis
      
//       // "\n",
//       // centerText("THANK YOU!") + "\n",
//       // centerText("Aura Meditation Center") + "\n",
//       // "\n",
//       divider("*"),
//       centerText("Generated: " + new Date().toLocaleString('en-LK')) + "\n",
//       "\n\n\n\n\n", // Extra lines for paper cut
//       gs + "V" + "\x41" + "\x03" // Cut paper
//     ];

//     return lines.join("");
//   };

//   const printThermalReceipt = async () => {
//     if (isPrinting) return;
    
//     setIsPrinting(true);
    
//     try {
//       // Connect to printer first
//       if (!qz.websocket.isActive()) {
//         await qz.websocket.connect();
//       }
//       const config = qz.configs.create(PRINTER_NAME);

//       const printData = generateAppointmentReceipt();

//       // Print the receipt
//       console.log("Printing thermal appointment receipt...");
//       await qz.print(config, [{ type: "raw", format: "command", data: printData }]);
//       console.log("Thermal appointment receipt printed successfully");

//       showMessage('Appointment receipt printed successfully!', 'success');
//       onClose();
//     } catch (err) {
//       console.error("Print process failed:", err);
//       showMessage("Print error: " + err.message, 'error');
//     } finally {
//       setIsPrinting(false);
//     }
//   };

//   return (
//     <>
//       <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
//         <DialogTitle>
//           <Box display="flex" alignItems="center" gap={1}>
//             <ReceiptLong color="primary" />
//             QZ Tray Thermal Printing - Appointment
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//             Direct printing to thermal printer using QZ Tray
//           </Typography>
          
//           <Card variant="outlined" sx={{ mb: 3 }}>
//             <CardContent>
//               <Typography variant="h6" gutterBottom>
//                 Appointment Receipt Preview (Thermal Format)
//               </Typography>
//               <Paper 
//                 variant="outlined" 
//                 sx={{ 
//                   p: 2, 
//                   backgroundColor: '#f5f5f5', 
//                   fontFamily: 'Courier New, monospace', 
//                   fontSize: '12px', 
//                   lineHeight: '1.2', 
//                   whiteSpace: 'pre',
//                   maxHeight: '400px',
//                   overflow: 'auto',
//                   border: '1px dashed #ccc'
//                 }}
//               >
//                 {generateAppointmentReceipt().replace(/\x1B\[.*?m/g, '')} {/* Remove escape sequences for preview */}
//               </Paper>
//             </CardContent>
//           </Card>

//           <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
//             <Typography variant="body2" color="text.secondary">
//               Printer: {PRINTER_NAME}
//             </Typography>
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={onClose}>Cancel</Button>
//           <Button 
//             onClick={printThermalReceipt} 
//             variant="contained" 
//             color="primary"
//             startIcon={<PrintIcon />}
//             disabled={isPrinting}
//           >
//             {isPrinting ? "Printing..." : "Print Thermal Receipt"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar 
//         open={printStatus.open} 
//         autoHideDuration={6000} 
//         onClose={() => setPrintStatus({ ...printStatus, open: false })}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert 
//           severity={printStatus.severity} 
//           onClose={() => setPrintStatus({ ...printStatus, open: false })}
//         >
//           {printStatus.message}
//         </Alert>
//       </Snackbar>
//     </>
//   );
// };

// // Responsive Appointments Modal Component
// const AppointmentsModal = ({ 
//   open, 
//   onClose, 
//   appointments, 
//   searchTerm, 
//   onSearchChange, 
//   isLoading, 
//   onStatusUpdate, 
//   onAddRecord, 
//   onCancelAppointment, 
//   onQZTrayPrint,
//   selectedSlotId,
//   onRefresh
// }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   const filteredAppointments = appointments.filter((appointment) =>
//     appointment.MAD_FULL_NAME.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const formatTime = (timeString) => {
//     return new Date(`1970-01-01T${timeString}`).toLocaleTimeString("en-LK", {
//       hour: "numeric",
//       minute: "numeric",
//       hour12: true,
//     });
//   };

//   // Mobile drawer content
//   const mobileContent = (
//     <Box sx={{ p: 2 }}>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//         <Typography variant="h6" fontWeight="bold" color="primary">
//           Appointments
//         </Typography>
//         <Box>
//           <IconButton onClick={onRefresh} size="small" color="primary">
//             <RefreshIcon />
//           </IconButton>
//           <IconButton onClick={onClose} size="small">
//             <CloseIcon />
//           </IconButton>
//         </Box>
//       </Box>

//       <TextField
//         size="small"
//         fullWidth
//         placeholder="Search patients..."
//         value={searchTerm}
//         onChange={onSearchChange}
//         InputProps={{
//           startAdornment: (
//             <InputAdornment position="start">
//               <SearchIcon color="primary" />
//             </InputAdornment>
//           ),
//         }}
//         sx={{ mb: 2 }}
//       />

//       {isLoading ? (
//         <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//           <CircularProgress />
//         </Box>
//       ) : filteredAppointments.length === 0 ? (
//         <Typography variant="body1" color="textSecondary" sx={{ textAlign: "center", py: 4 }}>
//           No appointments found for this timeslot
//         </Typography>
//       ) : (
//         <Box sx={{ maxHeight: '70vh', overflow: 'auto' }}>
//           {filteredAppointments.map((appointment) => (
//             <Card 
//               key={appointment.MAD_APPOINMENT_ID} 
//               sx={{ 
//                 mb: 2, 
//                 opacity: appointment.MAD_STATUS === "I" ? 0.6 : 1,
//                 backgroundColor: appointment.MAD_STATUS === "I" ? '#ffe6e6' : 'inherit'
//               }}
//             >
//               <CardContent sx={{ p: 2 }}>
//                 {/* Patient Header */}
//                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                   <Avatar sx={{ width: 40, height: 40, mr: 2 }}>
//                     {appointment.MAD_FULL_NAME.charAt(0)}
//                   </Avatar>
//                   <Box sx={{ flex: 1 }}>
//                     <Typography variant="subtitle1" fontWeight="bold">
//                       {appointment.MAD_FULL_NAME}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       {appointment.MAD_CONTACT}
//                     </Typography>
//                   </Box>
//                   <Chip
//                     label={appointment.MAD_PATIENT_NO}
//                     color="primary"
//                     size="small"
//                   />
//                 </Box>

//                 <Divider sx={{ my: 1 }} />

//                 {/* Appointment Details */}
//                 <Box sx={{ mb: 2 }}>
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
//                     <Typography variant="body2" color="text.secondary">Time:</Typography>
//                     <Typography variant="body2" fontWeight="medium">
//                       {formatTime(appointment.MAD_ALLOCATED_TIME)}
//                     </Typography>
//                   </Box>
                  
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                     <Typography variant="body2" color="text.secondary">Status:</Typography>
//                     {appointment.MAD_STATUS === "I" ? (
//                       <Chip label="Cancelled" color="error" size="small" />
//                     ) : appointment.MAD_STATUS === "c" ? (
//                       <Chip
//                         icon={<CheckCircleIcon fontSize="small" />}
//                         label="Completed"
//                         color="success"
//                         size="small"
//                       />
//                     ) : appointment.TreatmentStatus === "G" ? (
//                       <Chip
//                         icon={<CheckCircleIcon fontSize="small" />}
//                         label="Invoice Genarated"
//                         color="success"
//                         size="small"
//                       />
//                     ) : appointment.TreatmentStatus === "P" ? (
//                       <Chip
//                         icon={<CheckCircleIcon fontSize="small" />}
//                         label="Preparation Complete"
//                         color="info"
//                         size="small"
//                         clickable
//                         onClick={() => onStatusUpdate(appointment)}
//                       />
//                     ) : (
//                       <Chip
//                         icon={<PendingIcon fontSize="small" />}
//                         label="Preparation Complete"
//                         color="warning"
//                         size="small"
//                         clickable
//                         onClick={() => onStatusUpdate(appointment)}
//                       />
//                     )}
//                   </Box>
//                 </Box>

//                 <Divider sx={{ my: 1 }} />

//                 {/* Action Buttons */}
//                 <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//                   <Button
//                     variant="outlined"
//                     size="small"
//                     fullWidth
//                     startIcon={<AddIcon />}
//                     onClick={() => {
//                       onAddRecord(
//                         appointment.MAD_PATIENT_CODE,
//                         appointment.MAD_APPOINMENT_ID,
//                         appointment.MAD_PATIENT_NO
//                       );
//                       onClose();
//                     }}
//                     disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
//                   >
//                     Add Treatment
//                   </Button>
                  
//                   <Button
//                     variant="outlined"
//                     size="small"
//                     color="error"
//                     fullWidth
//                     startIcon={<CloseIcon />}
//                     onClick={() => onCancelAppointment(appointment.MAD_APPOINMENT_ID)}
//                     disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
//                   >
//                     Cancel Appointment
//                   </Button>
                  
//                   <Button
//                     variant="contained"
//                     size="small"
//                     color="secondary"
//                     fullWidth
//                     startIcon={<PrintIcon />}
//                     onClick={() => onQZTrayPrint(appointment)}
//                   >
//                     Print Appointment Receipt
//                   </Button>
//                 </Box>
//               </CardContent>
//             </Card>
//           ))}
//         </Box>
//       )}
//     </Box>
//   );

//   // Desktop table content
//   const desktopContent = (
//     <>
//       <DialogTitle>
//         <Box display="flex" justifyContent="space-between" alignItems="center">
//           <Typography variant="h5" component="h2" fontWeight="bold" color="primary">
//             Appointments
//           </Typography>
//           <Box display="flex" alignItems="center" gap={1}>
//             <Button
//               startIcon={<RefreshIcon />}
//               onClick={onRefresh}
//               size="small"
//               variant="outlined"
//             >
//               Refresh
//             </Button>
//             <IconButton onClick={onClose}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </Box>
//       </DialogTitle>
      
//       <DialogContent dividers>
//         <Box sx={{ mb: 2 }}>
//           <TextField
//             size="small"
//             fullWidth
//             placeholder="Search patients..."
//             value={searchTerm}
//             onChange={onSearchChange}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start" sx={{ color: "primary.main" }}>
//                   <SearchIcon />
//                 </InputAdornment>
//               ),
//             }}
//           />
//         </Box>

//         {isLoading ? (
//           <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//             <CircularProgress />
//           </Box>
//         ) : filteredAppointments.length === 0 ? (
//           <Typography variant="body1" color="textSecondary" sx={{ textAlign: "center", py: 4 }}>
//             No appointments found for this timeslot
//           </Typography>
//         ) : (
//           <TableContainer>
//             <Table size="medium">
//               <TableHead sx={{ backgroundColor: theme.palette.primary.light }}>
//                 <TableRow>
//                   <TableCell sx={{ color: "white", fontWeight: "bold" }}>Patient</TableCell>
//                   <TableCell sx={{ color: "white", fontWeight: "bold" }}>Contact</TableCell>
//                   <TableCell sx={{ color: "white", fontWeight: "bold" }}>Time</TableCell>
//                   <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>No.</TableCell>
//                   <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>Status</TableCell>
//                   <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>Action</TableCell>
//                 </TableRow>
//               </TableHead>

//               <TableBody>
//                 {filteredAppointments.map((appointment) => (
//                   <TableRow
//                     key={appointment.MAD_APPOINMENT_ID}
//                     hover
//                     sx={{
//                       opacity: appointment.MAD_STATUS === "I" ? 0.6 : 1,
//                       backgroundColor: appointment.MAD_STATUS === "I" ? '#ffe6e6' : 'inherit'
//                     }}
//                   >
//                     <TableCell>
//                       <Box sx={{ display: "flex", alignItems: "center" }}>
//                         <Avatar sx={{ width: 32, height: 32, mr: 1 }}>
//                           {appointment.MAD_FULL_NAME.charAt(0)}
//                         </Avatar>
//                         {appointment.MAD_FULL_NAME}
//                       </Box>
//                     </TableCell>
//                     <TableCell>{appointment.MAD_CONTACT}</TableCell>
//                     <TableCell>
//                       {formatTime(appointment.MAD_ALLOCATED_TIME)}
//                     </TableCell>
//                     <TableCell align="center">
//                       <Chip
//                         label={appointment.MAD_PATIENT_NO}
//                         color="primary"
//                         size="small"
//                       />
//                     </TableCell>
                   
//                     <TableCell align="center">
//                       {appointment.MAD_STATUS === "I" ? (
//                         <Chip
//                           label="Cancelled"
//                           color="error"
//                           size="small"
//                         />
//                       ) : appointment.MAD_STATUS === "c" ? (
//                           <Chip
//                             icon={<CheckCircleIcon fontSize="small" />}
//                             label="Completed"
//                             color="success"
//                             size="small"
//                           />
//                         ): appointment.TreatmentStatus === "G" ? (
//                         <Chip
//                           icon={<CheckCircleIcon fontSize="small" />}
//                           label="Invoice Genarated"
//                           color="success"
//                           size="small"
//                         />
//                       ) : appointment.TreatmentStatus === "P" ? (
//                         <Chip
//                           icon={<CheckCircleIcon fontSize="small" />}
//                           label="Preparation Complete"
//                           color="info"
//                           size="small"
//                           clickable
//                           onClick={() => onStatusUpdate(appointment)}
//                         />
//                       ) : (
//                         <Chip
//                           icon={<PendingIcon fontSize="small" />}
//                           label="Preparation Complete"
//                           color="warning"
//                           size="small"
//                           clickable
//                           onClick={() => onStatusUpdate(appointment)}
//                         />
//                       )}
//                     </TableCell>
//                     <TableCell align="center" sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//                       <Button
//                         variant="outlined"
//                         size="small"
//                         startIcon={<AddIcon />}
//                         onClick={() => {
//                           onAddRecord(
//                             appointment.MAD_PATIENT_CODE,
//                             appointment.MAD_APPOINMENT_ID,
//                             appointment.MAD_PATIENT_NO
//                           );
//                           onClose();
//                         }}
//                         disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
//                       >
//                         Add Treatment
//                       </Button>
//                       <Button
//                         variant="outlined"
//                         size="small"
//                         color="error"
//                         startIcon={<CloseIcon />}
//                         onClick={() => onCancelAppointment(appointment.MAD_APPOINMENT_ID)}
//                         disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
//                       >
//                         Cancel
//                       </Button>
                      
//                       <Button
//                         variant="contained"
//                         size="small"
//                         color="secondary"
//                         startIcon={<PrintIcon />}
//                         onClick={() => onQZTrayPrint(appointment)}
//                       >
//                         Receipt
//                       </Button>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         )}
//       </DialogContent>
//     </>
//   );

//   if (isMobile) {
//     return (
//       <Drawer
//         anchor="bottom"
//         open={open}
//         onClose={onClose}
//         sx={{
//           '& .MuiDrawer-paper': {
//             borderTopLeftRadius: 16,
//             borderTopRightRadius: 16,
//             maxHeight: '90vh',
//           },
//         }}
//       >
//         {mobileContent}
//       </Drawer>
//     );
//   }

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       fullWidth
//       maxWidth="lg"
//     >
//       {desktopContent}
//     </Dialog>
//   );
// };

// export default function DailyAppointment() {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const navigate = useNavigate();

//   const [timeslots, setTimeslots] = useState([]);
//   const [error, setError] = useState(null);
//   const [appointments, setAppointments] = useState([]);
//   const [selectedSlotId, setSelectedSlotId] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const Name = localStorage.getItem("Name");
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("info");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [qzTrayDialogOpen, setQzTrayDialogOpen] = useState(false);
//   const [selectedAppointment, setSelectedAppointment] = useState(null);
//   const [selectedDate, setSelectedDate] = useState(() => {
//     const now = new Date();
//     const year = now.getFullYear();
//     const month = String(now.getMonth() + 1).padStart(2, '0');
//     const day = String(now.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   });

//   const showSnackbar = (message, severity = "info") => {
//     setSnackbarMessage(message);
//     setSnackbarSeverity(severity);
//     setSnackbarOpen(true);
//   };

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   // Auto-refresh appointments every 1 minute when modal is open
//   useEffect(() => {
//     let intervalId;

//     if (isModalOpen && selectedSlotId) {
//       // Refresh immediately when modal opens
//       handleRefreshAppointments();

//       // Set up interval for auto-refresh every 1 minute
//       intervalId = setInterval(() => {
//         handleRefreshAppointments();
//       }, 30000); // 60 seconds = 1 minute

//       showSnackbar("Auto-refresh enabled - updating every minute", "info");
//     }

//     // Cleanup interval on modal close or component unmount
//     return () => {
//       if (intervalId) {
//         clearInterval(intervalId);
//         console.log("Auto-refresh interval cleared");
//       }
//     };
//   }, [isModalOpen, selectedSlotId]);

//   const fetchTimeslotsByDate = async () => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/Timeslot/active-timeslots?date=${selectedDate}`
//       );
//       setTimeslots(response.data);
//       setError(null);
//     } catch (error) {
//       setTimeslots([]);
//       setError("No timeslots available for the selected date.");
//       console.error("Error fetching timeslots:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (selectedDate) {
//       fetchTimeslotsByDate();
//     }
//   }, [selectedDate]);

//   const handleViewAppointments = async (slotId) => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/appointments/${slotId}`
//       );
//       setAppointments(response.data);
//       setSelectedSlotId(slotId);
//       setIsModalOpen(true);
//       showSnackbar(`Loaded ${response.data.length} appointments`, "success");
//     } catch (error) {
//       console.error("Error fetching appointments:", error);
//       showSnackbar("No appointments available for this timeslot", "info");
//       setAppointments([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Manual refresh function
//   const handleRefreshAppointments = async () => {
//     if (!selectedSlotId) return;
    
//     try {
//       console.log("Refreshing appointments...");
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/appointments/${selectedSlotId}`
//       );
//       setAppointments(response.data);
//       console.log(`Refreshed ${response.data.length} appointments`);
//     } catch (error) {
//       console.error("Error refreshing appointments:", error);
//       showSnackbar("Failed to refresh appointments", "error");
//     }
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedSlotId(null);
//     setSearchTerm("");
//   };

//   const handleStatusUpdate = async (appointment) => {
//     try {
//       const patientCode = appointment.MAD_PATIENT_CODE;
//       const appointmentID = appointment.MAD_APPOINMENT_ID;
      
//       console.log('Updating status with:', { patientCode, appointmentID });  
//       const response = await axios.put(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/status/${appointmentID}`,
//         JSON.stringify("c"), 
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       if (response.status === 200) {
//         console.log('Status updated successfully');
//         showSnackbar("Status updated to completed", "success");
        
//         // Refresh the appointments data
//         handleRefreshAppointments();
//       }
//     } catch (error) {
//       console.error('Error updating status:', error);
//       showSnackbar("Failed to update status", "error");
//     }
//   };

//   const handleAddRecord = (patientId, appointmentID, patientNo) => {
//     navigate(`/dashboard/addrecord/${patientId}`, {
//       state: { appointmentid: appointmentID, channelnumber: patientNo, MTD_APPOINMENT_ID: appointmentID },
//     });
//   };

//   const handlePrintAppointment = (appointmentId, patientCode, patientName, allocatedTime, patientNo) => {
//     const printWindow = window.open('', '_blank');
    
//     const formattedTime = formatTime(allocatedTime);
//     const currentDate = new Date().toLocaleDateString('en-LK');
//     const currentTime = new Date().toLocaleTimeString('en-LK', { 
//       hour: '2-digit', 
//       minute: '2-digit',
//       hour12: false 
//     });

//     printWindow.document.write(`
//       <html>
//         <head>
//           <title>Appointment Details - ${appointmentId}</title>
//           <style>
//             * {
//               margin: 0;
//               padding: 0;
//               box-sizing: border-box;
//             }
            
//             body { 
//               font-family: Arial, sans-serif; 
//               margin: 0;
//               padding: 5px;
//               background: #ffffff;
//               color: #000000;
//               line-height: 1.2;
//               font-size: 10px;
//             }
            
//             .print-container {
//               width: 100%;
//               max-width: 200px;
//               margin: 0 auto;
//               border: 1px solid #000000;
//               border-radius: 3px;
//               padding: 8px;
//               background: #ffffff;
//             }
            
//             .header {
//               text-align: center;
//               margin-bottom: 8px;
//               padding-bottom: 5px;
//               border-bottom: 1px solid #000000;
//             }
            
//             .clinic-name {
//               font-size: 21px;
//               font-weight: bold;
//               color: #000000;
//               margin-bottom: 2px;
//             }
            
//             .document-title {
//               font-size: 18px;
//               font-weight: bold;
//               color: #000000;
//             }
            
//             .main-info {
//               margin: 8px 0;
//               padding: 6px;
//               border: 2px solid #000000;
//               border-radius: 3px;
//               background: #ffff00;
//               text-align: center;
//             }
            
//             .info-label {
//               font-size: 18px;
//               font-weight: bold;
//               color: #000000;
//               margin-bottom: 3px;
//             }
            
//             .info-value {
//               font-size: 36px;
//               font-weight: bold;
//               color: #000000;
//               margin: 4px 0;
//             }
            
//             .patient-info {
//               background: #ffffff;
//               padding: 6px;
//               border: 1px solid #000000;
//               border-radius: 2px;
//               margin: 8px 0;
//             }
            
//             .detail-row {
//               display: flex;
//               justify-content: space-between;
//               margin-bottom: 3px;
//               font-size: 18px;
//             }
            
//             .detail-label {
//               font-weight: bold;
//               color: #000000;
//             }
            
//             .detail-value {
//               font-weight: normal;
//               color: #000000;
//               text-align: right;
//             }
            
//             .arrival-notice {
//               background: #000000;
//               color: #ffffff;
//               padding: 6px;
//               border-radius: 4px;
//               margin: 10px 0 0 0;
//               text-align: center;
//               font-weight: bold;
//               font-size: 18px;
//             }
            
//             @media print {
//               body { 
//                 margin: 0;
//                 padding: 3px;
//               }
//               .print-container {
//                 border: 1px solid #000000 !important;
//                 box-shadow: none !important;
//                 margin: 0 !important;
//                 max-width: 100% !important;
//                 transform: scale(0.9);
//               }
//               .no-print { display: none !important; }
//             }
//           </style>
//         </head>
//         <body>
//           <div class="print-container">
//             <div class="header">
//               <div class="clinic-name">Aura Meditation Center</div>
//               <div class="document-title">APPOINTMENT CONFIRMATION</div>
//             </div>
            
//             <div class="main-info">         
//               <div class="info-label">Channel Number</div>
//               <div class="info-value">${patientNo}</div>
//             </div>
            
//             <div class="patient-info">
//               <div class="detail-row">
//                 <span class="detail-label">Name:</span>
//                 <span class="detail-value">${patientName}</span>
//               </div>
//               <div class="detail-row">
//                 <span class="detail-label">Time:</span>
//                 <span class="detail-value">${formattedTime}</span>
//               </div>
//               <div class="detail-row">
//                 <span class="detail-label">Date:</span>
//                 <span class="detail-value">${currentDate}</span>
//               </div>
//             </div>

//             <div class="arrival-notice">
//               ARRIVE 15 MIN EARLY
//             </div>
//           </div>

//           <script>
//             window.onload = function() {
//               window.print();
//               setTimeout(function() {
//                 window.close();
//               }, 500);
//             };
//           </script>
//         </body>
//       </html>
//     `);
//     printWindow.document.close();
    
//     showSnackbar("Opening print preview...", "info");
//   };

//   // New function for QZ Tray thermal printing
//   const handleQZTrayPrint = (appointment) => {
//     setSelectedAppointment(appointment);
//     setQzTrayDialogOpen(true);
//   };

//   const handleDateChange = (e) => {
//     setSelectedDate(e.target.value);
//     setAppointments([]);
//     setSelectedSlotId(null);
//   };

//   const formatTime = (timeString) => {
//     return new Date(`1970-01-01T${timeString}`).toLocaleTimeString("en-LK", {
//       hour: "numeric",
//       minute: "numeric",
//       hour12: true,
//     });
//   };

//   const handleCancelAppointment = async (appointmentId) => {
//     try {
//       setIsLoading(true);
//       await axios.delete(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/cancel-appointment/${appointmentId}`
//       );

//       setAppointments(appointments.map(appt =>
//         appt.MAD_APPOINMENT_ID === appointmentId
//           ? { ...appt, MAD_STATUS: "I" }
//           : appt
//       ));

//       showSnackbar("Appointment cancelled successfully", "success");
//     } catch (error) {
//       console.error("Error cancelling appointment:", error);
//       showSnackbar("Failed to cancel appointment", "error");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <Container maxWidth="xl" sx={{ py: 3 }}>
//       <Paper elevation={3} sx={{ p: 4 }}>
//         <Box
//           sx={{
//             mb: 4,
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//           }}
//         >
//           <Typography
//             variant="h4"
//             component="h1"
//             gutterBottom
//             color="primary"
//             fontWeight={600}
//             align="center"
//           >
//             Daily Appointments
//           </Typography>

        
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: isMobile ? "column" : "row",
//               gap: 2,
//               mb: 3,
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             <TextField
//               type="date"
//               label="Select Date"
//               value={selectedDate}
//               onChange={handleDateChange}
//               InputLabelProps={{ shrink: true }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <DateRangeIcon sx={{ color: "primary.main" }} />
//                   </InputAdornment>
//                 ),
//               }}
//               inputProps={{
//                 placeholder: "YYYY/MM/DD"
//               }}
//               sx={{
//                 minWidth: isMobile ? "100%" : 250,
//                 '& .MuiInputBase-input': {
//                   position: 'relative',
//                   backgroundColor: 'transparent',
//                 },
//                 '& input[type="date"]': {
//                   color: 'transparent',
//                   position: 'relative',
//                   '&::-webkit-calendar-picker-indicator': {
//                     opacity: 0,
//                     position: 'absolute',
//                     left: 0,
//                     top: 0,
//                     width: '100%',
//                     height: '100%',
//                     cursor: 'pointer',
//                     zIndex: 2,
//                   },
//                 },
//                 '& .MuiInputBase-root': {
//                   position: 'relative',
//                   '&::after': {
//                     content: selectedDate
//                       ? `"${selectedDate.split('-').join('/')}"`
//                       : '"YYYY/MM/DD"',
//                     position: 'absolute',
//                     left: '40px',
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     color: selectedDate ? 'rgba(0, 0, 0, 0.87)' : 'rgba(0, 0, 0, 0.6)',
//                     fontSize: '14px',
//                     fontFamily: 'inherit',
//                     pointerEvents: 'none',
//                     zIndex: 1,
//                   }
//                 }
//               }}
//             />
//           </Box>
//         </Box>

//         {isLoading && !selectedSlotId ? (
//           <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//             <CircularProgress />
//           </Box>
//         ) : error ? (
//           <Paper elevation={3} sx={{ p: 3, textAlign: "center" }}>
//             <Typography variant="h6" color="textSecondary">
//               {error}
//             </Typography>
//           </Paper>
//         ) : (
//           <Grid container spacing={3}>
//             <Grid item xs={12}>
//               <Typography
//                 variant="h6"
//                 gutterBottom
//                 color="primary"
//                 fontWeight={600}
//               >
//                 Available Timeslots
//               </Typography>
//               <Grid container spacing={2}>
//                 {timeslots.map((timeslot) => (
//                   <Grid item xs={12} key={timeslot.MT_SLOT_ID}>
//                     <Card
//                       elevation={3}
//                       sx={{
//                         borderLeft:
//                           selectedSlotId === timeslot.MT_SLOT_ID
//                             ? `4px solid ${theme.palette.primary.main}`
//                             : "none",
//                         cursor: "pointer",
//                         "&:hover": {
//                           boxShadow: 4,
//                         },
//                       }}
//                       onClick={() =>
//                         handleViewAppointments(timeslot.MT_SLOT_ID)
//                       }
//                     >
//                       <CardContent>
//                         <Box
//                           sx={{ display: "flex", alignItems: "center", mb: 1 }}
//                         >
//                           <Avatar
//                             sx={{ bgcolor: theme.palette.primary.main, mr: 2 }}
//                           >
//                             <PersonIcon />
//                           </Avatar>
//                           <Typography variant="subtitle1">
//                             {timeslot.MT_DOCTOR}
//                           </Typography>
//                         </Box>
//                         <Box sx={{ display: "flex", alignItems: "center" }}>
//                           <TimeIcon color="action" sx={{ mr: 1 }} />
//                           <Typography>
//                             {formatTime(timeslot.MT_START_TIME)} -{" "}
//                             {formatTime(timeslot.MT_END_TIME)}
//                           </Typography>
//                         </Box>
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 ))}
//               </Grid>
//             </Grid>
//           </Grid>
//         )}

//         {/* Responsive Appointments Modal */}
//         <AppointmentsModal
//           open={isModalOpen}
//           onClose={handleCloseModal}
//           appointments={appointments}
//           searchTerm={searchTerm}
//           onSearchChange={(e) => setSearchTerm(e.target.value)}
//           isLoading={isLoading}
//           onStatusUpdate={handleStatusUpdate}
//           onAddRecord={handleAddRecord}
//           onCancelAppointment={handleCancelAppointment}
//           onQZTrayPrint={handleQZTrayPrint}
//           selectedSlotId={selectedSlotId}
//           onRefresh={handleRefreshAppointments}
//         />

//         {/* QZ Tray Thermal Printing Dialog */}
//         <QZTrayAppointmentPrint
//           open={qzTrayDialogOpen}
//           onClose={() => setQzTrayDialogOpen(false)}
//           appointment={selectedAppointment}
//         />

//         <Snackbar
//           open={snackbarOpen}
//           autoHideDuration={6000}
//           onClose={handleSnackbarClose}
//           anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         >
//           <Alert
//             onClose={handleSnackbarClose}
//             severity={snackbarSeverity}
//             sx={{ width: "100%" }}
//           >
//             {snackbarMessage}
//           </Alert>
//         </Snackbar>
//       </Paper>
//     </Container>
//   );
// }


//working for our printer

// import { useEffect, useState } from "react";
// import axios from "axios";
// import { useLocation, useNavigate } from "react-router-dom";
// import {
//   Box,
//   Button,
//   Card,
//   CardContent,
//   CircularProgress,
//   Container,
//   Grid,
//   IconButton,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TextField,
//   Typography,
//   Chip,
//   useTheme,
//   useMediaQuery,
//   Avatar,
//   Divider,
//   Snackbar,
//   Alert,
//   InputAdornment,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Drawer,
//   MenuItem,
//   FormControl,
//   Select,
// } from "@mui/material";
// import {
//   DateRange as DateRangeIcon,
//   AccessTime as TimeIcon,
//   Person as PersonIcon,
//   Add as AddIcon,
//   CheckCircle as CheckCircleIcon,
//   Pending as PendingIcon,
//   Search as SearchIcon,
//   Refresh as RefreshIcon,
//   Close as CloseIcon,
//   Print as PrintIcon,
//   Usb as UsbIcon,
//   CloudUpload as CloudUploadIcon,
//   AutoAwesome as AutoAwesomeIcon,
//   Download as DownloadIcon,
// } from "@mui/icons-material";
// import auralogo from "../assets/AuraLogo.ico";

// // Enhanced Thermal Print Component using Browser Print with ESC/POS Simulation
// const ThermalPrintDialog = ({ 
//   open, 
//   onClose, 
//   appointment 
// }) => {
//   const [isPrinting, setIsPrinting] = useState(false);
//   const [printMethod, setPrintMethod] = useState('browser');
//   const [status, setStatus] = useState('');

//   const formatTime = (timeString) => {
//     return new Date(`1970-01-01T${timeString}`).toLocaleTimeString("en-LK", {
//       hour: "numeric",
//       minute: "numeric",
//       hour12: true,
//     });
//   };

//   // Generate ESC/POS commands for thermal printers
//   const generateEscPosCommands = () => {
//     const currentDate = new Date().toLocaleDateString('en-LK');
//     const currentTime = new Date().toLocaleTimeString('en-LK', { 
//       hour: '2-digit', 
//       minute: '2-digit',
//       hour12: false 
//     });

//     // ESC/POS commands
//     const commands = [
//       '\x1B\x40', // Initialize printer
//       '\x1B\x61\x01', // Center alignment
//       '\x1B\x21\x30', // Double height and width
//       'AURA MEDITATION CENTER\n',
//       '\x1B\x21\x00', // Normal text
//       '\x1B\x61\x00', // Left alignment
//       '================================\n',
//       '\x1B\x61\x01', // Center alignment
//       '\x1B\x45\x01', // Bold on
//       'APPOINTMENT CONFIRMATION\n',
//       '\x1B\x45\x00', // Bold off
//       '================================\n',
//       '\x1B\x61\x00', // Left alignment
//       `Patient: ${appointment?.MAD_FULL_NAME || 'N/A'}\n`,
//       // `Time: ${formatTime(appointment?.MAD_ALLOCATED_TIME)}\n`,
//       // `Contact: ${appointment?.MAD_CONTACT || 'N/A'}\n`,
//       // `Date: ${currentDate}\n`,
//       '\n',
//       '================================\n',
//       '\x1B\x61\x01', // Center alignment
//       '\x1B\x21\x30', // Double height and width
//       'CHANNEL NUMBER\n',
//       `${appointment?.MAD_PATIENT_NO || 'N/A'}\n`,
//       '\x1B\x21\x00', // Normal text
//       '\n',
//       '================================\n',
//       '\x1B\x45\x01', // Bold on
//       'ARRIVE 30 MINUTES EARLY\n',
//       '\x1B\x45\x00', // Bold off
//       '\n',
//       // 'THANK YOU!\n',
//       // 'Aura Meditation Center\n',
//       // '\n',
//       // '********************************\n',
//       // `Generated: ${currentDate} ${currentTime}\n`,
//       '\n\n\n\n',
//       '\x1D\x56\x41\x03' // Cut paper
//     ];

//     return commands.join('');
//   };

//   // Method 1: Browser Print with Thermal Printer CSS
//   const handleBrowserPrint = () => {
//     setIsPrinting(true);
//     setStatus('Preparing print...');

//     const printContent = `
//       <!DOCTYPE html>
//       <html>
//       <head>
//         <title>Appointment Receipt - Aura Meditation Center</title>
//        <style>
//   @media print {
//     @page {
//       margin: 0;
//       size: 80mm 150mm;
//       margin: 2mm;
//     }
    
//     body {
//       margin: 0;
//       padding: 2mm;
//       font-family: 'Courier New', monospace;
//       font-size: 10px;
//       line-height: 1.2;
//       width: 76mm;
//       background: white;
//       color: black;
//       -webkit-print-color-adjust: exact;
//       print-color-adjust: exact;
//     }
    
//     .receipt {
//       width: 76mm;
//       margin: 0 auto;
//     }
    
//     .header {
//       text-align: center;
//       margin-bottom: 3px;
//     }
    
//     .center {
//       text-align: center;
//     }
    
//     .bold {
//       font-weight: bold;
//     }
    
//     .large {
//       font-size: 14px;
//       font-weight: bold;
//     }
    
//     .x-large {
//       font-size: 16px;
//       font-weight: bold;
//     }
    
//     .divider {
//       border-bottom: 2px solid #000; /* Thicker and darker */
//       margin: 3px 0;
//       height: 2px;
//     }
    
//     .double-divider {
//       border-bottom: 3px solid #000; /* Thicker and darker */
//       margin: 4px 0;
//       height: 3px;
//     }
    
//     .channel-number {
//       text-align: center;
//       margin: 8px 0;
//       padding: 5px;
//       border: 3px solid #000; /* Thicker border */
//       background: #f0f0f0; /* Light gray background */
//     }
    
//     .important {
//       background: #000 !important;
//       color: #fff !important;
//       padding: 4px;
//       text-align: center;
//       margin: 6px 0;
//       -webkit-print-color-adjust: exact;
//       print-color-adjust: exact;
//       border: 1px solid #000; /* Added border */
//     }
    
//     .footer {
//       text-align: center;
//       margin-top: 10px;
//       font-weight: bold;
//     }
    
//     .logo {
//       text-align: center;
//       margin-bottom: 5px;
//     }
    
//     .logo-img {
//       max-width: 35mm;
//       height: auto;
//       filter: grayscale(100%) contrast(300%) brightness(40%) saturate(0%); /* Much darker */
//     }
    
//     .text-left {
//       text-align: left;
//     }
    
//     .text-right {
//       text-align: right;
//     }
    
//     .row {
//       display: flex;
//       justify-content: space-between;
//       margin: 2px 0;
//       border-bottom: 1px solid #333; /* Added subtle separator */
//       padding-bottom: 1px;
//     }

//     /* Additional darkening styles */
//     .header .x-large {
//       text-shadow: 0.5px 0.5px 0.5px #000; /* Subtle text shadow */
//     }
    
//     .channel-number .x-large {
//       text-shadow: 0.5px 0.5px 0.5px #000; /* Subtle text shadow */
//     }
    
//     .receipt {
//       box-shadow: 0 0 0 1px #000; /* Outer border */
//     }
//   }
  
//   /* Hide everything when printing */
//   @media screen {
//     body {
//       background: #f5f5f5;
//       padding: 20px;
//     }
//     .receipt {
//       border: 2px dashed #666; /* Darker dashed border for screen */
//       background: white;
//       padding: 10px;
//     }
//   }
// </style>
//       </head>
//       <body>
//         <div class="receipt">
//           <div class="logo">
//             <img src="${auralogo}" alt="Aura Meditation Center" class="logo-img">
//           </div>
          
//           <div class="header">
//             <div class="x-large">AURA MEDITATION CENTER</div>
//             <div class="double-divider"></div>
//             <div class="large">APPOINTMENT CONFIRMATION</div>
//             <div class="double-divider"></div>
//           </div>
          
//           <div class="text-left">
//             <div class="row">
//               <span class="bold">Patient:</span>
//               <span>${appointment?.MAD_FULL_NAME || 'N/A'}</span>
//             </div>
           
//           </div>
          
//           <div class="divider"></div>
          
//           <div class="channel-number">
//             <div class="x-large">CHANNEL NUMBER</div>
//             <div class="x-large">${appointment?.MAD_PATIENT_NO || 'N/A'}</div>
//           </div>
          
//           <div class="divider"></div>
          
//           <div class="important">
//             ARRIVE 30 MINUTES EARLY
//           </div>
          
//           <div class="footer">
//             <div class="bold">THANK YOU!</div>
//             <div class="bold">Aura Meditation Center</div>
//           </div>
          
//           <div class="divider"></div>
          
//           <div class="center">
//             <small>Generated: ${new Date().toLocaleString('en-LK')}</small>
//           </div>
//         </div>
        
//         <script>
//           // Auto-print and close
//           window.onload = function() {
//             setTimeout(function() {
//               window.print();
//               setTimeout(function() {
//                 window.close();
//               }, 500);
//             }, 500);
//           };
          
//           // Fallback for print issues
//           setTimeout(function() {
//             if (!document.hidden) {
//               window.print();
//               setTimeout(function() {
//                 window.close();
//               }, 500);
//             }
//           }, 3000);
//         </script>
//       </body>
//       </html>
//     `;

//     const printWindow = window.open('', '_blank', 'width=400,height=600');
//     if (printWindow) {
//       printWindow.document.write(printContent);
//       printWindow.document.close();
//       setStatus('Print dialog opened');
//     } else {
//       setStatus('Failed to open print window. Please allow popups.');
//     }
    
//     setTimeout(() => {
//       setIsPrinting(false);
//       onClose();
//     }, 2000);
//   };

//   // Method 2: Download ESC/POS file for manual transfer
//   const handleDownloadEscPos = () => {
//     setIsPrinting(true);
//     setStatus('Generating ESC/POS file...');
    
//     try {
//       const escPosData = generateEscPosCommands();
      
//       // Create a blob and download link
//       const blob = new Blob([escPosData], { type: 'application/octet-stream' });
//       const url = URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = `appointment-${appointment?.MAD_PATIENT_NO || 'receipt'}.txt`;
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);
//       URL.revokeObjectURL(url);
      
//       setStatus('ESC/POS file downloaded. Transfer to printer manually.');
//       setTimeout(() => {
//         setIsPrinting(false);
//         onClose();
//       }, 2000);
//     } catch (error) {
//       setStatus('Error generating file: ' + error.message);
//       setIsPrinting(false);
//     }
//   };

//   // Method 3: Server-side printing
//   const handleServerPrint = async () => {
//     setIsPrinting(true);
//     setStatus('Sending to server printer...');
    
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/print/appointment`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ 
//           appointment,
//           type: 'thermal',
//           timestamp: new Date().toISOString()
//         }),
//       });
      
//       if (response.ok) {
//         const result = await response.json();
//         setStatus('Print job sent to server successfully!');
//         setTimeout(() => {
//           setIsPrinting(false);
//           onClose();
//         }, 1500);
//       } else {
//         throw new Error('Server returned error: ' + response.status);
//       }
//     } catch (error) {
//       setStatus('Server printing failed: ' + error.message);
//       // Fallback to browser print
//       setTimeout(() => {
//         setStatus('Falling back to browser print...');
//         handleBrowserPrint();
//       }, 1500);
//     }
//   };

//   // Method 4: Image-based print for better compatibility
//   const handleImagePrint = () => {
//     setIsPrinting(true);
//     setStatus('Generating printable image...');
    
//     const printContent = `
//       <!DOCTYPE html>
//       <html>
//       <head>
//         <title>Print Receipt</title>
//         <style>
//           @page { margin: 0; size: 80mm auto; }
//           body { 
//             margin: 2mm; 
//             font-family: Arial, sans-serif;
//             font-size: 9px;
//             line-height: 1.1;
//             width: 76mm;
//           }
//           .container { 
//             border: 1px solid #000; 
//             padding: 3mm;
//             text-align: center;
//           }
//           .header { font-size: 11px; font-weight: bold; margin-bottom: 2mm; }
//           .channel { font-size: 14px; font-weight: bold; margin: 3mm 0; border: 2px solid #000; padding: 2mm; }
//           .important { background: #000; color: #fff; padding: 2mm; margin: 2mm 0; }
//           .footer { margin-top: 3mm; font-weight: bold; }
//         </style>
//       </head>
//       <body>
//         <div class="container">
//           <div class="header">AURA MEDITATION CENTER<br>APPOINTMENT CONFIRMATION</div>
//           <div style="border-bottom: 1px solid #000; margin: 2mm 0;"></div>
//           <div style="text-align: left;">
//             <div><strong>Patient:</strong> ${appointment?.MAD_FULL_NAME || 'N/A'}</div>
//             <div><strong>Time:</strong> ${formatTime(appointment?.MAD_ALLOCATED_TIME)}</div>
//             <div><strong>Contact:</strong> ${appointment?.MAD_CONTACT || 'N/A'}</div>
//             <div><strong>Date:</strong> ${new Date().toLocaleDateString('en-LK')}</div>
//           </div>
//           <div style="border-bottom: 1px solid #000; margin: 2mm 0;"></div>
//           <div class="channel">CHANNEL NUMBER<br>${appointment?.MAD_PATIENT_NO || 'N/A'}</div>
//           <div style="border-bottom: 1px solid #000; margin: 2mm 0;"></div>
//           <div class="important">ARRIVE 30 MINUTES EARLY</div>
//           <div class="footer">THANK YOU!<br>Aura Meditation Center</div>
//           <div style="font-size: 7px; margin-top: 3mm;">Printed: ${new Date().toLocaleString('en-LK')}</div>
//         </div>
//         <script>
//           setTimeout(() => window.print(), 500);
//           setTimeout(() => window.close(), 2000);
//         </script>
//       </body>
//       </html>
//     `;

//     const printWindow = window.open('', '_blank');
//     printWindow.document.write(printContent);
//     printWindow.document.close();
    
//     setTimeout(() => {
//       setIsPrinting(false);
//       onClose();
//     }, 3000);
//   };

//   const handlePrint = () => {
//     switch (printMethod) {
//       case 'browser':
//         handleBrowserPrint();
//         break;
//       case 'server':
//         handleServerPrint();
//         break;
//       case 'download':
//         handleDownloadEscPos();
//         break;
//       case 'image':
//         handleImagePrint();
//         break;
//       default:
//         handleBrowserPrint();
//     }
//   };

//   const printMethods = [
//     {
//       id: 'browser',
//       name: 'Browser Thermal Print',
//       description: 'Optimized for thermal printers with proper formatting',
//       icon: <PrintIcon />,
//     },
//     {
//       id: 'image',
//       name: 'Simple Print',
//       description: 'Basic printable format for any printer',
//       icon: <PrintIcon />,
//     },
//     {
//       id: 'download',
//       name: 'Download ESC/POS File',
//       description: 'Download file for manual transfer to thermal printer',
//       icon: <DownloadIcon />,
//     },
//     {
//       id: 'server',
//       name: 'Server Print',
//       description: 'Send to network/shared printer',
//       icon: <CloudUploadIcon />,
//     }
//   ];

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//       <DialogTitle>
//         Print Appointment Receipt
//       </DialogTitle>
//       <DialogContent>
//         <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//           Select printing method for thermal receipt
//         </Typography>
        
//         <FormControl fullWidth sx={{ mb: 3 }}>
//           <Select
//             value={printMethod}
//             onChange={(e) => setPrintMethod(e.target.value)}
//             disabled={isPrinting}
//           >
//             {printMethods.map(method => (
//               <MenuItem key={method.id} value={method.id}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                   {method.icon}
//                   <Box>
//                     <Typography variant="body2" fontWeight="bold">
//                       {method.name}
//                     </Typography>
//                     <Typography variant="caption" color="text.secondary">
//                       {method.description}
//                     </Typography>
//                   </Box>
//                 </Box>
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>

//         {/* Print Preview */}
//         <Card variant="outlined" sx={{ mb: 2 }}>
//           <CardContent>
//             <Typography variant="h6" gutterBottom>
//               Receipt Preview
//             </Typography>
//             <Paper 
//               sx={{ 
//                 p: 2, 
//                 backgroundColor: '#f5f5f5', 
//                 fontFamily: 'Courier New, monospace', 
//                 fontSize: '10px', 
//                 lineHeight: '1.2',
//                 border: '1px dashed #ccc'
//               }}
//             >
//               <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '12px' }}>
//                 AURA MEDITATION CENTER
//               </div>
//               <div style={{ borderBottom: '1px solid #000', margin: '3px 0' }}></div>
//               <div style={{ textAlign: 'center', fontWeight: 'bold' }}>APPOINTMENT CONFIRMATION</div>
//               <div style={{ borderBottom: '1px solid #000', margin: '3px 0' }}></div>
//               <div>Patient: {appointment?.MAD_FULL_NAME || 'N/A'}</div>
//               <div>Time: {formatTime(appointment?.MAD_ALLOCATED_TIME)}</div>
//               <div>Contact: {appointment?.MAD_CONTACT || 'N/A'}</div>
//               <div>Date: {new Date().toLocaleDateString('en-LK')}</div>
//               <div style={{ borderBottom: '1px solid #000', margin: '3px 0' }}></div>
//               <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '14px', margin: '5px 0' }}>
//                 CHANNEL NUMBER<br/>
//                 {appointment?.MAD_PATIENT_NO || 'N/A'}
//               </div>
//               <div style={{ borderBottom: '1px solid #000', margin: '3px 0' }}></div>
//               <div style={{ background: '#000', color: '#fff', textAlign: 'center', padding: '2px', margin: '3px 0' }}>
//                 ARRIVE 30 MINUTES EARLY
//               </div>
//               <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
//                 THANK YOU!<br/>Aura Meditation Center
//               </div>
//             </Paper>
//           </CardContent>
//         </Card>

//         {status && (
//           <Alert severity="info" sx={{ mb: 2 }}>
//             {status}
//           </Alert>
//         )}
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose} disabled={isPrinting}>
//           Cancel
//         </Button>
//         <Button 
//           onClick={handlePrint}
//           variant="contained"
//           disabled={isPrinting}
//           startIcon={isPrinting ? <CircularProgress size={16} /> : <PrintIcon />}
//         >
//           {isPrinting ? 'Printing...' : 'Print Receipt'}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// // Universal Printing Component (Simplified)
// const UniversalPrintDialog = ({ 
//   open, 
//   onClose, 
//   appointment,
//   onThermalPrint
// }) => {
//   const [isPrinting, setIsPrinting] = useState(false);

//   const handleQuickPrint = () => {
//     onClose();
//     onThermalPrint();
//   };

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//       <DialogTitle>
//         Print Options
//       </DialogTitle>
//       <DialogContent>
//         <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//           Choose how to print the appointment receipt
//         </Typography>
        
//         <Grid container spacing={2}>
//           <Grid item xs={12}>
//             <Card 
//               variant="outlined" 
//               sx={{ cursor: 'pointer', '&:hover': { backgroundColor: 'action.hover' } }}
//               onClick={handleQuickPrint}
//             >
//               <CardContent>
//                 <Box display="flex" alignItems="center" gap={2}>
//                   <PrintIcon color="primary" />
//                   <Box>
//                     <Typography variant="h6">
//                       Thermal Receipt Print
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       Optimized for thermal printers with multiple format options
//                     </Typography>
//                   </Box>
//                 </Box>
//               </CardContent>
//             </Card>
//           </Grid>
//         </Grid>
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose}>
//           Cancel
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// // Keep the existing AppointmentsModal component exactly as is
// const AppointmentsModal = ({ 
//   open, 
//   onClose, 
//   appointments, 
//   searchTerm, 
//   onSearchChange, 
//   isLoading, 
//   onStatusUpdate, 
//   onAddRecord, 
//   onCancelAppointment, 
//   onPrintAppointment,
//   selectedSlotId,
//   onRefresh
// }) => {
//   // ... (keep the exact same AppointmentsModal component code from your original)
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   const filteredAppointments = appointments.filter((appointment) =>
//     appointment.MAD_FULL_NAME.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const formatTime = (timeString) => {
//     return new Date(`1970-01-01T${timeString}`).toLocaleTimeString("en-LK", {
//       hour: "numeric",
//       minute: "numeric",
//       hour12: true,
//     });
//   };

//   // Mobile drawer content
//   const mobileContent = (
//     <Box sx={{ p: 2 }}>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//         <Typography variant="h6" fontWeight="bold" color="primary">
//           Appointments
//         </Typography>
//         <Box>
//           <IconButton onClick={onRefresh} size="small" color="primary">
//             <RefreshIcon />
//           </IconButton>
//           <IconButton onClick={onClose} size="small">
//             <CloseIcon />
//           </IconButton>
//         </Box>
//       </Box>

//       <TextField
//         size="small"
//         fullWidth
//         placeholder="Search patients..."
//         value={searchTerm}
//         onChange={onSearchChange}
//         InputProps={{
//           startAdornment: (
//             <InputAdornment position="start">
//               <SearchIcon color="primary" />
//             </InputAdornment>
//           ),
//         }}
//         sx={{ mb: 2 }}
//       />

//       {isLoading ? (
//         <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//           <CircularProgress />
//         </Box>
//       ) : filteredAppointments.length === 0 ? (
//         <Typography variant="body1" color="textSecondary" sx={{ textAlign: "center", py: 4 }}>
//           No appointments found for this timeslot
//         </Typography>
//       ) : (
//         <Box sx={{ maxHeight: '70vh', overflow: 'auto' }}>
//           {filteredAppointments.map((appointment) => (
//             <Card 
//               key={appointment.MAD_APPOINMENT_ID} 
//               sx={{ 
//                 mb: 2, 
//                 opacity: appointment.MAD_STATUS === "I" ? 0.6 : 1,
//                 backgroundColor: appointment.MAD_STATUS === "I" ? '#ffe6e6' : 'inherit'
//               }}
//             >
//               <CardContent sx={{ p: 2 }}>
//                 {/* Patient Header */}
//                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                   <Avatar sx={{ width: 40, height: 40, mr: 2 }}>
//                     {appointment.MAD_FULL_NAME.charAt(0)}
//                   </Avatar>
//                   <Box sx={{ flex: 1 }}>
//                     <Typography variant="subtitle1" fontWeight="bold">
//                       {appointment.MAD_FULL_NAME}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       {appointment.MAD_CONTACT}
//                     </Typography>
//                   </Box>
//                   <Chip
//                     label={appointment.MAD_PATIENT_NO}
//                     color="primary"
//                     size="small"
//                   />
//                 </Box>

//                 <Divider sx={{ my: 1 }} />

//                 {/* Appointment Details */}
//                 <Box sx={{ mb: 2 }}>
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
//                     <Typography variant="body2" color="text.secondary">Time:</Typography>
//                     <Typography variant="body2" fontWeight="medium">
//                       {formatTime(appointment.MAD_ALLOCATED_TIME)}
//                     </Typography>
//                   </Box>
                  
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                     <Typography variant="body2" color="text.secondary">Status:</Typography>
//                     {appointment.MAD_STATUS === "I" ? (
//                       <Chip label="Cancelled" color="error" size="small" />
//                     ) : appointment.MAD_STATUS === "c" ? (
//                       <Chip
//                         icon={<CheckCircleIcon fontSize="small" />}
//                         label="Completed"
//                         color="success"
//                         size="small"
//                       />
//                     ) : appointment.TreatmentStatus === "C" ? (
//                       <Chip
//                         icon={<CheckCircleIcon fontSize="small" />}
//                         label="Completed"
//                         color="success"
//                         size="small"
//                       />
//                     ) : appointment.TreatmentStatus === "P" ? (
//                       <Chip
//                         icon={<CheckCircleIcon fontSize="small" />}
//                         label="Preparation Complete"
//                         color="info"
//                         size="small"
//                         clickable
//                         onClick={() => onStatusUpdate(appointment)}
//                       />
//                     ) : (
//                       <Chip
//                         icon={<PendingIcon fontSize="small" />}
//                         label="Preparation Complete"
//                         color="warning"
//                         size="small"
//                         clickable
//                         onClick={() => onStatusUpdate(appointment)}
//                       />
//                     )}
//                   </Box>
//                 </Box>

//                 <Divider sx={{ my: 1 }} />

//                 {/* Action Buttons */}
//                 <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//                   <Button
//                     variant="outlined"
//                     size="small"
//                     fullWidth
//                     startIcon={<AddIcon />}
//                     onClick={() => {
//                       onAddRecord(
//                         appointment.MAD_PATIENT_CODE,
//                         appointment.MAD_APPOINMENT_ID,
//                         appointment.MAD_PATIENT_NO
//                       );
//                       onClose();
//                     }}
//                     disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
//                   >
//                     Add Treatment
//                   </Button>
                  
//                   <Button
//                     variant="outlined"
//                     size="small"
//                     color="error"
//                     fullWidth
//                     startIcon={<CloseIcon />}
//                     onClick={() => onCancelAppointment(appointment.MAD_APPOINMENT_ID)}
//                     disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
//                   >
//                     Cancel Appointment
//                   </Button>
                  
//                   <Button
//                     variant="contained"
//                     size="small"
//                     color="secondary"
//                     fullWidth
//                     startIcon={<PrintIcon />}
//                     onClick={() => onPrintAppointment(appointment)}
//                   >
//                     Print Receipt
//                   </Button>
//                 </Box>
//               </CardContent>
//             </Card>
//           ))}
//         </Box>
//       )}
//     </Box>
//   );

//   // Desktop table content
//   const desktopContent = (
//     <>
//       <DialogTitle>
//         <Box display="flex" justifyContent="space-between" alignItems="center">
//           <Typography variant="h5" component="h2" fontWeight="bold" color="primary">
//             Appointments
//           </Typography>
//           <Box display="flex" alignItems="center" gap={1}>
//             <Button
//               startIcon={<RefreshIcon />}
//               onClick={onRefresh}
//               size="small"
//               variant="outlined"
//             >
//               Refresh
//             </Button>
//             <IconButton onClick={onClose}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </Box>
//       </DialogTitle>
      
//       <DialogContent dividers>
//         <Box sx={{ mb: 2 }}>
//           <TextField
//             size="small"
//             fullWidth
//             placeholder="Search patients..."
//             value={searchTerm}
//             onChange={onSearchChange}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start" sx={{ color: "primary.main" }}>
//                   <SearchIcon />
//                 </InputAdornment>
//               ),
//             }}
//           />
//         </Box>

//         {isLoading ? (
//           <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//             <CircularProgress />
//           </Box>
//         ) : filteredAppointments.length === 0 ? (
//           <Typography variant="body1" color="textSecondary" sx={{ textAlign: "center", py: 4 }}>
//             No appointments found for this timeslot
//           </Typography>
//         ) : (
//           <TableContainer>
//             <Table size="medium">
//               <TableHead sx={{ backgroundColor: theme.palette.primary.light }}>
//                 <TableRow>
//                   <TableCell sx={{ color: "white", fontWeight: "bold" }}>Patient</TableCell>
//                   <TableCell sx={{ color: "white", fontWeight: "bold" }}>Contact</TableCell>
//                   <TableCell sx={{ color: "white", fontWeight: "bold" }}>Time</TableCell>
//                   <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>No.</TableCell>
//                   <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>Status</TableCell>
//                   <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>Action</TableCell>
//                 </TableRow>
//               </TableHead>

//               <TableBody>
//                 {filteredAppointments.map((appointment) => (
//                   <TableRow
//                     key={appointment.MAD_APPOINMENT_ID}
//                     hover
//                     sx={{
//                       opacity: appointment.MAD_STATUS === "I" ? 0.6 : 1,
//                       backgroundColor: appointment.MAD_STATUS === "I" ? '#ffe6e6' : 'inherit'
//                     }}
//                   >
//                     <TableCell>
//                       <Box sx={{ display: "flex", alignItems: "center" }}>
//                         <Avatar sx={{ width: 32, height: 32, mr: 1 }}>
//                           {appointment.MAD_FULL_NAME.charAt(0)}
//                         </Avatar>
//                         {appointment.MAD_FULL_NAME}
//                       </Box>
//                     </TableCell>
//                     <TableCell>{appointment.MAD_CONTACT}</TableCell>
//                     <TableCell>
//                       {formatTime(appointment.MAD_ALLOCATED_TIME)}
//                     </TableCell>
//                     <TableCell align="center">
//                       <Chip
//                         label={appointment.MAD_PATIENT_NO}
//                         color="primary"
//                         size="small"
//                       />
//                     </TableCell>
                   
//                     <TableCell align="center">
//                       {appointment.MAD_STATUS === "I" ? (
//                         <Chip
//                           label="Cancelled"
//                           color="error"
//                           size="small"
//                         />
//                       ) : appointment.MAD_STATUS === "c" ? (
//                           <Chip
//                             icon={<CheckCircleIcon fontSize="small" />}
//                             label="Completed"
//                             color="success"
//                             size="small"
//                           />
//                         ): appointment.TreatmentStatus === "C" ? (
//                         <Chip
//                           icon={<CheckCircleIcon fontSize="small" />}
//                           label="Completed"
//                           color="success"
//                           size="small"
//                         />
//                       ) : appointment.TreatmentStatus === "P" ? (
//                         <Chip
//                           icon={<CheckCircleIcon fontSize="small" />}
//                           label="Preparation Complete"
//                           color="info"
//                           size="small"
//                           clickable
//                           onClick={() => onStatusUpdate(appointment)}
//                         />
//                       ) : (
//                         <Chip
//                           icon={<PendingIcon fontSize="small" />}
//                           label="Preparation Complete"
//                           color="warning"
//                           size="small"
//                           clickable
//                           onClick={() => onStatusUpdate(appointment)}
//                         />
//                       )}
//                     </TableCell>
//                     <TableCell align="center" sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//                       <Button
//                         variant="outlined"
//                         size="small"
//                         startIcon={<AddIcon />}
//                         onClick={() => {
//                           onAddRecord(
//                             appointment.MAD_PATIENT_CODE,
//                             appointment.MAD_APPOINMENT_ID,
//                             appointment.MAD_PATIENT_NO
//                           );
//                           onClose();
//                         }}
//                         disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
//                       >
//                         Add Treatment
//                       </Button>
//                       <Button
//                         variant="outlined"
//                         size="small"
//                         color="error"
//                         startIcon={<CloseIcon />}
//                         onClick={() => onCancelAppointment(appointment.MAD_APPOINMENT_ID)}
//                         disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
//                       >
//                         Cancel
//                       </Button>
                      
//                       <Button
//                         variant="contained"
//                         size="small"
//                         color="secondary"
//                         startIcon={<PrintIcon />}
//                         onClick={() => onPrintAppointment(appointment)}
//                       >
//                         Receipt
//                       </Button>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         )}
//       </DialogContent>
//     </>
//   );

//   if (isMobile) {
//     return (
//       <Drawer
//         anchor="bottom"
//         open={open}
//         onClose={onClose}
//         sx={{
//           '& .MuiDrawer-paper': {
//             borderTopLeftRadius: 16,
//             borderTopRightRadius: 16,
//             maxHeight: '90vh',
//           },
//         }}
//       >
//         {mobileContent}
//       </Drawer>
//     );
//   }

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       fullWidth
//       maxWidth="lg"
//     >
//       {desktopContent}
//     </Dialog>
//   );
// };

// // Main Component
// export default function DailyAppointment() {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const navigate = useNavigate();

//   const [timeslots, setTimeslots] = useState([]);
//   const [error, setError] = useState(null);
//   const [appointments, setAppointments] = useState([]);
//   const [selectedSlotId, setSelectedSlotId] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("info");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [universalPrintDialogOpen, setUniversalPrintDialogOpen] = useState(false);
//   const [thermalPrintDialogOpen, setThermalPrintDialogOpen] = useState(false);
//   const [selectedAppointment, setSelectedAppointment] = useState(null);
//   const [selectedDate, setSelectedDate] = useState(() => {
//     const now = new Date();
//     const year = now.getFullYear();
//     const month = String(now.getMonth() + 1).padStart(2, '0');
//     const day = String(now.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   });

//   const showSnackbar = (message, severity = "info") => {
//     setSnackbarMessage(message);
//     setSnackbarSeverity(severity);
//     setSnackbarOpen(true);
//   };

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   // Auto-refresh appointments every 1 minute when modal is open
//   useEffect(() => {
//     let intervalId;

//     if (isModalOpen && selectedSlotId) {
//       // Refresh immediately when modal opens
//       handleRefreshAppointments();

//       // Set up interval for auto-refresh every 1 minute
//       intervalId = setInterval(() => {
//         handleRefreshAppointments();
//       }, 60000); // 60 seconds = 1 minute

//       showSnackbar("Auto-refresh enabled - updating every minute", "info");
//     }

//     // Cleanup interval on modal close or component unmount
//     return () => {
//       if (intervalId) {
//         clearInterval(intervalId);
//         console.log("Auto-refresh interval cleared");
//       }
//     };
//   }, [isModalOpen, selectedSlotId]);

//   const fetchTimeslotsByDate = async () => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/Timeslot/active-timeslots?date=${selectedDate}`
//       );
//       setTimeslots(response.data);
//       setError(null);
//     } catch (error) {
//       setTimeslots([]);
//       setError("No timeslots available for the selected date.");
//       console.error("Error fetching timeslots:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (selectedDate) {
//       fetchTimeslotsByDate();
//     }
//   }, [selectedDate]);

//   const handleViewAppointments = async (slotId) => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/appointments/${slotId}`
//       );
//       setAppointments(response.data);
//       setSelectedSlotId(slotId);
//       setIsModalOpen(true);
//       showSnackbar(`Loaded ${response.data.length} appointments`, "success");
//     } catch (error) {
//       console.error("Error fetching appointments:", error);
//       showSnackbar("No appointments available for this timeslot", "info");
//       setAppointments([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Manual refresh function
//   const handleRefreshAppointments = async () => {
//     if (!selectedSlotId) return;
    
//     try {
//       console.log("Refreshing appointments...");
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/appointments/${selectedSlotId}`
//       );
//       setAppointments(response.data);
//       console.log(`Refreshed ${response.data.length} appointments`);
//     } catch (error) {
//       console.error("Error refreshing appointments:", error);
//       showSnackbar("Failed to refresh appointments", "error");
//     }
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedSlotId(null);
//     setSearchTerm("");
//   };

//   const handleStatusUpdate = async (appointment) => {
//     try {
//       const patientCode = appointment.MAD_PATIENT_CODE;
//       const appointmentID = appointment.MAD_APPOINMENT_ID;
      
//       console.log('Updating status with:', { patientCode, appointmentID });  
//       const response = await axios.put(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/status/${appointmentID}`,
//         JSON.stringify("c"), 
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       if (response.status === 200) {
//         console.log('Status updated successfully');
//         showSnackbar("Status updated to completed", "success");
        
//         // Refresh the appointments data
//         handleRefreshAppointments();
//       }
//     } catch (error) {
//       console.error('Error updating status:', error);
//       showSnackbar("Failed to update status", "error");
//     }
//   };

//   const handleAddRecord = (patientId, appointmentID, patientNo) => {
//     navigate(`/dashboard/addrecord/${patientId}`, {
//       state: { appointmentid: appointmentID, channelnumber: patientNo, MTD_APPOINMENT_ID: appointmentID },
//     });
//   };

//   const handlePrintAppointment = (appointment) => {
//     setSelectedAppointment(appointment);
//     setUniversalPrintDialogOpen(true);
//   };

//   const handleThermalPrint = () => {
//     setThermalPrintDialogOpen(true);
//   };

//   const handleDateChange = (e) => {
//     setSelectedDate(e.target.value);
//     setAppointments([]);
//     setSelectedSlotId(null);
//   };

//   const formatTime = (timeString) => {
//     return new Date(`1970-01-01T${timeString}`).toLocaleTimeString("en-LK", {
//       hour: "numeric",
//       minute: "numeric",
//       hour12: true,
//     });
//   };

//   const handleCancelAppointment = async (appointmentId) => {
//     try {
//       setIsLoading(true);
//       await axios.delete(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/cancel-appointment/${appointmentId}`
//       );

//       setAppointments(appointments.map(appt =>
//         appt.MAD_APPOINMENT_ID === appointmentId
//           ? { ...appt, MAD_STATUS: "I" }
//           : appt
//       ));

//       showSnackbar("Appointment cancelled successfully", "success");
//     } catch (error) {
//       console.error("Error cancelling appointment:", error);
//       showSnackbar("Failed to cancel appointment", "error");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <Container maxWidth="xl" sx={{ py: 3 }}>
//       <Paper elevation={3} sx={{ p: 4 }}>
//         <Box
//           sx={{
//             mb: 4,
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//           }}
//         >
//           <Typography
//             variant="h4"
//             component="h1"
//             gutterBottom
//             color="primary"
//             fontWeight={600}
//             align="center"
//           >
//             Daily Appointments
//           </Typography>

        
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: isMobile ? "column" : "row",
//               gap: 2,
//               mb: 3,
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             <TextField
//               type="date"
//               label="Select Date"
//               value={selectedDate}
//               onChange={handleDateChange}
//               InputLabelProps={{ shrink: true }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <DateRangeIcon sx={{ color: "primary.main" }} />
//                   </InputAdornment>
//                 ),
//               }}
//               inputProps={{
//                 placeholder: "YYYY/MM/DD"
//               }}
//               sx={{
//                 minWidth: isMobile ? "100%" : 250,
//                 '& .MuiInputBase-input': {
//                   position: 'relative',
//                   backgroundColor: 'transparent',
//                 },
//                 '& input[type="date"]': {
//                   color: 'transparent',
//                   position: 'relative',
//                   '&::-webkit-calendar-picker-indicator': {
//                     opacity: 0,
//                     position: 'absolute',
//                     left: 0,
//                     top: 0,
//                     width: '100%',
//                     height: '100%',
//                     cursor: 'pointer',
//                     zIndex: 2,
//                   },
//                 },
//                 '& .MuiInputBase-root': {
//                   position: 'relative',
//                   '&::after': {
//                     content: selectedDate
//                       ? `"${selectedDate.split('-').join('/')}"`
//                       : '"YYYY/MM/DD"',
//                     position: 'absolute',
//                     left: '40px',
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     color: selectedDate ? 'rgba(0, 0, 0, 0.87)' : 'rgba(0, 0, 0, 0.6)',
//                     fontSize: '14px',
//                     fontFamily: 'inherit',
//                     pointerEvents: 'none',
//                     zIndex: 1,
//                   }
//                 }
//               }}
//             />
//           </Box>
//         </Box>

//         {isLoading && !selectedSlotId ? (
//           <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//             <CircularProgress />
//           </Box>
//         ) : error ? (
//           <Paper elevation={3} sx={{ p: 3, textAlign: "center" }}>
//             <Typography variant="h6" color="textSecondary">
//               {error}
//             </Typography>
//           </Paper>
//         ) : (
//           <Grid container spacing={3}>
//             <Grid item xs={12}>
//               <Typography
//                 variant="h6"
//                 gutterBottom
//                 color="primary"
//                 fontWeight={600}
//               >
//                 Available Timeslots
//               </Typography>
//               <Grid container spacing={2}>
//                 {timeslots.map((timeslot) => (
//                   <Grid item xs={12} key={timeslot.MT_SLOT_ID}>
//                     <Card
//                       elevation={3}
//                       sx={{
//                         borderLeft:
//                           selectedSlotId === timeslot.MT_SLOT_ID
//                             ? `4px solid ${theme.palette.primary.main}`
//                             : "none",
//                         cursor: "pointer",
//                         "&:hover": {
//                           boxShadow: 4,
//                         },
//                       }}
//                       onClick={() =>
//                         handleViewAppointments(timeslot.MT_SLOT_ID)
//                       }
//                     >
//                       <CardContent>
//                         <Box
//                           sx={{ display: "flex", alignItems: "center", mb: 1 }}
//                         >
//                           <Avatar
//                             sx={{ bgcolor: theme.palette.primary.main, mr: 2 }}
//                           >
//                             <PersonIcon />
//                           </Avatar>
//                           <Typography variant="subtitle1">
//                             {timeslot.MT_DOCTOR}
//                           </Typography>
//                         </Box>
//                         <Box sx={{ display: "flex", alignItems: "center" }}>
//                           <TimeIcon color="action" sx={{ mr: 1 }} />
//                           <Typography>
//                             {formatTime(timeslot.MT_START_TIME)} -{" "}
//                             {formatTime(timeslot.MT_END_TIME)}
//                           </Typography>
//                         </Box>
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 ))}
//               </Grid>
//             </Grid>
//           </Grid>
//         )}

//         {/* Responsive Appointments Modal */}
//         <AppointmentsModal
//           open={isModalOpen}
//           onClose={handleCloseModal}
//           appointments={appointments}
//           searchTerm={searchTerm}
//           onSearchChange={(e) => setSearchTerm(e.target.value)}
//           isLoading={isLoading}
//           onStatusUpdate={handleStatusUpdate}
//           onAddRecord={handleAddRecord}
//           onCancelAppointment={handleCancelAppointment}
//           onPrintAppointment={handlePrintAppointment}
//           selectedSlotId={selectedSlotId}
//           onRefresh={handleRefreshAppointments}
//         />

//         {/* Universal Printing Dialog */}
//         <UniversalPrintDialog
//           open={universalPrintDialogOpen}
//           onClose={() => setUniversalPrintDialogOpen(false)}
//           appointment={selectedAppointment}
//           onThermalPrint={handleThermalPrint}
//         />

//         {/* Thermal Printing Dialog */}
//         <ThermalPrintDialog
//           open={thermalPrintDialogOpen}
//           onClose={() => setThermalPrintDialogOpen(false)}
//           appointment={selectedAppointment}
//         />

//         <Snackbar
//           open={snackbarOpen}
//           autoHideDuration={6000}
//           onClose={handleSnackbarClose}
//           anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         >
//           <Alert
//             onClose={handleSnackbarClose}
//             severity={snackbarSeverity}
//             sx={{ width: "100%" }}
//           >
//             {snackbarMessage}
//           </Alert>
//         </Snackbar>
//       </Paper>
//     </Container>
//   );
// }



//QZ working now 


// import { useEffect, useState } from "react";
// import axios from "axios";
// import { useLocation, useNavigate } from "react-router-dom";
// import {
//   Box,
//   Button,
//   Card,
//   CardContent,
//   CircularProgress,
//   Container,
//   Grid,
//   IconButton,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TextField,
//   Typography,
//   Chip,
//   useTheme,
//   useMediaQuery,
//   Avatar,
//   Badge,
//   Divider,
//   Snackbar,
//   Alert,
//   InputAdornment,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Drawer,
// } from "@mui/material";
// import {
//   DateRange as DateRangeIcon,
//   AccessTime as TimeIcon,
//   Person as PersonIcon,
//   Phone as PhoneIcon,
//   Add as AddIcon,
//   CheckCircle as CheckCircleIcon,
//   Pending as PendingIcon,
//   Search as SearchIcon,
//   Refresh as RefreshIcon,
//   Close as CloseIcon,
//   Print as PrintIcon,
//   ReceiptLong,
// } from "@mui/icons-material";

// // QZ Tray imports
// import qz from "qz-tray";

// // Thermal printer configuration
// const PRINTER_NAME = "BIXOLON SRP-E302"; // Change to your thermal printer name

// // Enhanced Cash drawer commands for thermal printers
// const CASH_DRAWER_COMMANDS = {
//   OPEN_DRAWER_PIN2: "\x1B\x70\x00\x19\xFA",
//   OPEN_DRAWER_PIN5: "\x1B\x70\x01\x19\xFA",
//   ALTERNATE_1: "\x1B\x70\x00\x60\x60",
//   ALTERNATE_2: "\x1B\x70\x01\x60\x60",
//   BELL_COMMAND: "\x07",
// };

// // QZ Tray Thermal Printing Component for Appointments
// const QZTrayAppointmentPrint = ({ 
//   open, 
//   onClose, 
//   appointment 
// }) => {
//   const [printStatus, setPrintStatus] = useState({ open: false, message: '', severity: 'info' });
//   const [isPrinting, setIsPrinting] = useState(false);

//   const showMessage = (message, severity = 'info') => {
//     setPrintStatus({ open: true, message, severity });
//   };

//   // Thermal printer formatting constants
//   const esc = "\x1B";
//   const gs = "\x1D";
//   const LINE_WIDTH = 48; // 80mm thermal printer width

//   const leftRight = (left, right, width = LINE_WIDTH) => {
//     const space = width - (left.length + right.length);
//     return left + " ".repeat(space > 0 ? space : 1) + right;
//   };

//   const centerText = (text, width = LINE_WIDTH) => {
//     const padding = Math.max(0, Math.floor((width - text.length) / 2));
//     return " ".repeat(padding) + text;
//   };

//   const divider = (char = "-") => char.repeat(LINE_WIDTH) + "\n";

//   const formatTime = (timeString) => {
//     return new Date(`1970-01-01T${timeString}`).toLocaleTimeString("en-LK", {
//       hour: "numeric",
//       minute: "numeric",
//       hour12: true,
//     });
//   };

//   // Generate thermal appointment receipt commands for QZ Tray
//   const generateAppointmentReceipt = () => {
//     const currentDate = new Date().toLocaleDateString('en-LK');
//     const currentTime = new Date().toLocaleTimeString('en-LK', { 
//       hour: '2-digit', 
//       minute: '2-digit',
//       hour12: false 
//     });

//     const lines = [
//       esc + "@", // Initialize printer
      
//       // Company header - Center aligned and emphasized
//       esc + "a" + "\x01", // Center align
//       esc + "!" + "\x38", // Double height and emphasized
//       "AURA MEDITATION CENTER\n",
//       esc + "!" + "\x00", // Cancel text formatting
      
  
      
//       divider("="),
      
//       // Receipt title
//       esc + "!" + "\x12", // Medium size
//       esc + "a" + "\x01", // Center align
//       esc + "!" + "\x28", // Double height and emphasized
//       "APPOINTMENT CONFIRMATION\n",
//       esc + "!" + "\x00", // Cancel size
//       divider("="),
      
     
      
//       // Channel Number - Large and emphasized
//       esc + "a" + "\x01", // Center align
//       esc + "!" + "\x38", // Double height and emphasized
//       "APPOINTMENT NUMBER\n",
//       esc + "!" + "\x38", // Double height and emphasized
//       `${appointment?.MAD_PATIENT_NO || 'N/A'}\n`,
//       esc + "!" + "\x00", // Cancel size

//       esc + "!" + "\x08", // Emphasized normal size
//       `${appointment?.MAD_FULL_NAME || 'N/A'}\n`,
//       esc + "!" + "\x00", // Reset style
      
//       divider("="),
      
//       // Important notice
//       esc + "a" + "\x01", // Center align
//       esc + "!" + "\x08", // Emphasized
//       "Maximum Time 30 MINUTES \n",
//       esc + "!" + "\x00", // Cancel emphasis
      
//       // "\n",
//       // centerText("THANK YOU!") + "\n",
//       // centerText("Aura Meditation Center") + "\n",
//       // "\n",
//       divider("*"),
//       centerText("Generated: " + new Date().toLocaleString('en-LK')) + "\n",
//       "\n\n\n\n\n", // Extra lines for paper cut
//       gs + "V" + "\x41" + "\x03" // Cut paper
//     ];

//     return lines.join("");
//   };

//   const printThermalReceipt = async () => {
//     if (isPrinting) return;
    
//     setIsPrinting(true);
    
//     try {
//       // Connect to printer first
//       if (!qz.websocket.isActive()) {
//         await qz.websocket.connect();
//       }
//       const config = qz.configs.create(PRINTER_NAME);

//       const printData = generateAppointmentReceipt();

//       // Print the receipt
//       console.log("Printing thermal appointment receipt...");
//       await qz.print(config, [{ type: "raw", format: "command", data: printData }]);
//       console.log("Thermal appointment receipt printed successfully");

//       showMessage('Appointment receipt printed successfully!', 'success');
//       onClose();
//     } catch (err) {
//       console.error("Print process failed:", err);
//       showMessage("Print error: " + err.message, 'error');
//     } finally {
//       setIsPrinting(false);
//     }
//   };

//   return (
//     <>
//       <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
//         <DialogTitle>
//           <Box display="flex" alignItems="center" gap={1}>
//             <ReceiptLong color="primary" />
//             QZ Tray Thermal Printing - Appointment
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//             Direct printing to thermal printer using QZ Tray
//           </Typography>
          
//           <Card variant="outlined" sx={{ mb: 3 }}>
//             <CardContent>
//               <Typography variant="h6" gutterBottom>
//                 Appointment Receipt Preview (Thermal Format)
//               </Typography>
//               <Paper 
//                 variant="outlined" 
//                 sx={{ 
//                   p: 2, 
//                   backgroundColor: '#f5f5f5', 
//                   fontFamily: 'Courier New, monospace', 
//                   fontSize: '12px', 
//                   lineHeight: '1.2', 
//                   whiteSpace: 'pre',
//                   maxHeight: '400px',
//                   overflow: 'auto',
//                   border: '1px dashed #ccc'
//                 }}
//               >
//                 {generateAppointmentReceipt().replace(/\x1B\[.*?m/g, '')} {/* Remove escape sequences for preview */}
//               </Paper>
//             </CardContent>
//           </Card>

//           <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
//             <Typography variant="body2" color="text.secondary">
//               Printer: {PRINTER_NAME}
//             </Typography>
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={onClose}>Cancel</Button>
//           <Button 
//             onClick={printThermalReceipt} 
//             variant="contained" 
//             color="primary"
//             startIcon={<PrintIcon />}
//             disabled={isPrinting}
//           >
//             {isPrinting ? "Printing..." : "Print Thermal Receipt"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar 
//         open={printStatus.open} 
//         autoHideDuration={6000} 
//         onClose={() => setPrintStatus({ ...printStatus, open: false })}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert 
//           severity={printStatus.severity} 
//           onClose={() => setPrintStatus({ ...printStatus, open: false })}
//         >
//           {printStatus.message}
//         </Alert>
//       </Snackbar>
//     </>
//   );
// };

// // Responsive Appointments Modal Component
// const AppointmentsModal = ({ 
//   open, 
//   onClose, 
//   appointments, 
//   searchTerm, 
//   onSearchChange, 
//   isLoading, 
//   onStatusUpdate, 
//   onAddRecord, 
//   onCancelAppointment, 
//   onQZTrayPrint,
//   selectedSlotId,
//   onRefresh
// }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   const filteredAppointments = appointments.filter((appointment) =>
//     appointment.MAD_FULL_NAME.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const formatTime = (timeString) => {
//     return new Date(`1970-01-01T${timeString}`).toLocaleTimeString("en-LK", {
//       hour: "numeric",
//       minute: "numeric",
//       hour12: true,
//     });
//   };

//   // Mobile drawer content
//   const mobileContent = (
//     <Box sx={{ p: 2 }}>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//         <Typography variant="h6" fontWeight="bold" color="primary">
//           Appointments
//         </Typography>
//         <Box>
//           <IconButton onClick={onRefresh} size="small" color="primary">
//             <RefreshIcon />
//           </IconButton>
//           <IconButton onClick={onClose} size="small">
//             <CloseIcon />
//           </IconButton>
//         </Box>
//       </Box>

//       <TextField
//         size="small"
//         fullWidth
//         placeholder="Search patients..."
//         value={searchTerm}
//         onChange={onSearchChange}
//         InputProps={{
//           startAdornment: (
//             <InputAdornment position="start">
//               <SearchIcon color="primary" />
//             </InputAdornment>
//           ),
//         }}
//         sx={{ mb: 2 }}
//       />

//       {isLoading ? (
//         <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//           <CircularProgress />
//         </Box>
//       ) : filteredAppointments.length === 0 ? (
//         <Typography variant="body1" color="textSecondary" sx={{ textAlign: "center", py: 4 }}>
//           No appointments found for this timeslot
//         </Typography>
//       ) : (
//         <Box sx={{ maxHeight: '70vh', overflow: 'auto' }}>
//           {filteredAppointments.map((appointment) => (
//             <Card 
//               key={appointment.MAD_APPOINMENT_ID} 
//               sx={{ 
//                 mb: 2, 
//                 opacity: appointment.MAD_STATUS === "I" ? 0.6 : 1,
//                 backgroundColor: appointment.MAD_STATUS === "I" ? '#ffe6e6' : 'inherit'
//               }}
//             >
//               <CardContent sx={{ p: 2 }}>
//                 {/* Patient Header */}
//                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                   <Avatar sx={{ width: 40, height: 40, mr: 2 }}>
//                     {appointment.MAD_FULL_NAME.charAt(0)}
//                   </Avatar>
//                   <Box sx={{ flex: 1 }}>
//                     <Typography variant="subtitle1" fontWeight="bold">
//                       {appointment.MAD_FULL_NAME}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       {appointment.MAD_CONTACT}
//                     </Typography>
//                   </Box>
//                   <Chip
//                     label={appointment.MAD_PATIENT_NO}
//                     color="primary"
//                     size="small"
//                   />
//                 </Box>

//                 <Divider sx={{ my: 1 }} />

//                 {/* Appointment Details */}
//                 <Box sx={{ mb: 2 }}>
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
//                     <Typography variant="body2" color="text.secondary">Time:</Typography>
//                     <Typography variant="body2" fontWeight="medium">
//                       {formatTime(appointment.MAD_ALLOCATED_TIME)}
//                     </Typography>
//                   </Box>
                  
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                     <Typography variant="body2" color="text.secondary">Status:</Typography>
//                     {appointment.MAD_STATUS === "I" ? (
//                       <Chip label="Cancelled" color="error" size="small" />
//                     ) : appointment.MAD_STATUS === "c" ? (
//                       <Chip
//                         icon={<CheckCircleIcon fontSize="small" />}
//                         label="Completed"
//                         color="success"
//                         size="small"
//                       />
//                     ) : appointment.TreatmentStatus === "G" ? (
//                       <Chip
//                         icon={<CheckCircleIcon fontSize="small" />}
//                         label="Invoice Genarated"
//                         color="success"
//                         size="small"
//                       />
//                     ) : appointment.TreatmentStatus === "P" ? (
//                       <Chip
//                         icon={<CheckCircleIcon fontSize="small" />}
//                         label="Preparation Complete"
//                         color="info"
//                         size="small"
//                         clickable
//                         onClick={() => onStatusUpdate(appointment)}
//                       />
//                     ) : (
//                       <Chip
//                         icon={<PendingIcon fontSize="small" />}
//                         label="Preparation Complete"
//                         color="warning"
//                         size="small"
//                         clickable
//                         onClick={() => onStatusUpdate(appointment)}
//                       />
//                     )}
//                   </Box>
//                 </Box>

//                 <Divider sx={{ my: 1 }} />

//                 {/* Action Buttons */}
//                 <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//                   <Button
//                     variant="outlined"
//                     size="small"
//                     fullWidth
//                     startIcon={<AddIcon />}
//                     onClick={() => {
//                       onAddRecord(
//                         appointment.MAD_PATIENT_CODE,
//                         appointment.MAD_APPOINMENT_ID,
//                         appointment.MAD_PATIENT_NO
//                       );
//                       onClose();
//                     }}
//                     disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
//                   >
//                     Add Treatment
//                   </Button>
                  
//                   <Button
//                     variant="outlined"
//                     size="small"
//                     color="error"
//                     fullWidth
//                     startIcon={<CloseIcon />}
//                     onClick={() => onCancelAppointment(appointment.MAD_APPOINMENT_ID)}
//                     disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
//                   >
//                     Cancel Appointment
//                   </Button>
                  
//                   <Button
//                     variant="contained"
//                     size="small"
//                     color="secondary"
//                     fullWidth
//                     startIcon={<PrintIcon />}
//                     onClick={() => onQZTrayPrint(appointment)}
//                   >
//                     Print Appointment Receipt
//                   </Button>
//                 </Box>
//               </CardContent>
//             </Card>
//           ))}
//         </Box>
//       )}
//     </Box>
//   );

//   // Desktop table content
//   const desktopContent = (
//     <>
//       <DialogTitle>
//         <Box display="flex" justifyContent="space-between" alignItems="center">
//           <Typography variant="h5" component="h2" fontWeight="bold" color="primary">
//             Appointments
//           </Typography>
//           <Box display="flex" alignItems="center" gap={1}>
//             <Button
//               startIcon={<RefreshIcon />}
//               onClick={onRefresh}
//               size="small"
//               variant="outlined"
//             >
//               Refresh
//             </Button>
//             <IconButton onClick={onClose}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </Box>
//       </DialogTitle>
      
//       <DialogContent dividers>
//         <Box sx={{ mb: 2 }}>
//           <TextField
//             size="small"
//             fullWidth
//             placeholder="Search patients..."
//             value={searchTerm}
//             onChange={onSearchChange}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start" sx={{ color: "primary.main" }}>
//                   <SearchIcon />
//                 </InputAdornment>
//               ),
//             }}
//           />
//         </Box>

//         {isLoading ? (
//           <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//             <CircularProgress />
//           </Box>
//         ) : filteredAppointments.length === 0 ? (
//           <Typography variant="body1" color="textSecondary" sx={{ textAlign: "center", py: 4 }}>
//             No appointments found for this timeslot
//           </Typography>
//         ) : (
//           <TableContainer>
//             <Table size="medium">
//               <TableHead sx={{ backgroundColor: theme.palette.primary.light }}>
//                 <TableRow>
//                   <TableCell sx={{ color: "white", fontWeight: "bold" }}>Patient</TableCell>
//                   <TableCell sx={{ color: "white", fontWeight: "bold" }}>Contact</TableCell>
//                   <TableCell sx={{ color: "white", fontWeight: "bold" }}>Time</TableCell>
//                   <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>No.</TableCell>
//                   <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>Status</TableCell>
//                   <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>Action</TableCell>
//                 </TableRow>
//               </TableHead>

//               <TableBody>
//                 {filteredAppointments.map((appointment) => (
//                   <TableRow
//                     key={appointment.MAD_APPOINMENT_ID}
//                     hover
//                     sx={{
//                       opacity: appointment.MAD_STATUS === "I" ? 0.6 : 1,
//                       backgroundColor: appointment.MAD_STATUS === "I" ? '#ffe6e6' : 'inherit'
//                     }}
//                   >
//                     <TableCell>
//                       <Box sx={{ display: "flex", alignItems: "center" }}>
//                         <Avatar sx={{ width: 32, height: 32, mr: 1 }}>
//                           {appointment.MAD_FULL_NAME.charAt(0)}
//                         </Avatar>
//                         {appointment.MAD_FULL_NAME}
//                       </Box>
//                     </TableCell>
//                     <TableCell>{appointment.MAD_CONTACT}</TableCell>
//                     <TableCell>
//                       {formatTime(appointment.MAD_ALLOCATED_TIME)}
//                     </TableCell>
//                     <TableCell align="center">
//                       <Chip
//                         label={appointment.MAD_PATIENT_NO}
//                         color="primary"
//                         size="small"
//                       />
//                     </TableCell>
                   
//                     <TableCell align="center">
//                       {appointment.MAD_STATUS === "I" ? (
//                         <Chip
//                           label="Cancelled"
//                           color="error"
//                           size="small"
//                         />
//                       ) : appointment.MAD_STATUS === "c" ? (
//                           <Chip
//                             icon={<CheckCircleIcon fontSize="small" />}
//                             label="Completed"
//                             color="success"
//                             size="small"
//                           />
//                         ): appointment.TreatmentStatus === "G" ? (
//                         <Chip
//                           icon={<CheckCircleIcon fontSize="small" />}
//                           label="Invoice Genarated"
//                           color="success"
//                           size="small"
//                         />
//                       ) : appointment.TreatmentStatus === "P" ? (
//                         <Chip
//                           icon={<CheckCircleIcon fontSize="small" />}
//                           label="Preparation Complete"
//                           color="info"
//                           size="small"
//                           clickable
//                           onClick={() => onStatusUpdate(appointment)}
//                         />
//                       ) : (
//                         <Chip
//                           icon={<PendingIcon fontSize="small" />}
//                           label="Preparation Complete"
//                           color="warning"
//                           size="small"
//                           clickable
//                           onClick={() => onStatusUpdate(appointment)}
//                         />
//                       )}
//                     </TableCell>
//                     <TableCell align="center" sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//                       <Button
//                         variant="outlined"
//                         size="small"
//                         startIcon={<AddIcon />}
//                         onClick={() => {
//                           onAddRecord(
//                             appointment.MAD_PATIENT_CODE,
//                             appointment.MAD_APPOINMENT_ID,
//                             appointment.MAD_PATIENT_NO
//                           );
//                           onClose();
//                         }}
//                         disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
//                       >
//                         Add Treatment
//                       </Button>
//                       <Button
//                         variant="outlined"
//                         size="small"
//                         color="error"
//                         startIcon={<CloseIcon />}
//                         onClick={() => onCancelAppointment(appointment.MAD_APPOINMENT_ID)}
//                         disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
//                       >
//                         Cancel
//                       </Button>
                      
//                       <Button
//                         variant="contained"
//                         size="small"
//                         color="secondary"
//                         startIcon={<PrintIcon />}
//                         onClick={() => onQZTrayPrint(appointment)}
//                       >
//                         Receipt
//                       </Button>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         )}
//       </DialogContent>
//     </>
//   );

//   if (isMobile) {
//     return (
//       <Drawer
//         anchor="bottom"
//         open={open}
//         onClose={onClose}
//         sx={{
//           '& .MuiDrawer-paper': {
//             borderTopLeftRadius: 16,
//             borderTopRightRadius: 16,
//             maxHeight: '90vh',
//           },
//         }}
//       >
//         {mobileContent}
//       </Drawer>
//     );
//   }

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       fullWidth
//       maxWidth="lg"
//     >
//       {desktopContent}
//     </Dialog>
//   );
// };

// export default function DailyAppointment() {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const navigate = useNavigate();

//   const [timeslots, setTimeslots] = useState([]);
//   const [error, setError] = useState(null);
//   const [appointments, setAppointments] = useState([]);
//   const [selectedSlotId, setSelectedSlotId] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const Name = localStorage.getItem("Name");
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("info");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [qzTrayDialogOpen, setQzTrayDialogOpen] = useState(false);
//   const [selectedAppointment, setSelectedAppointment] = useState(null);
//   const [selectedDate, setSelectedDate] = useState(() => {
//     const now = new Date();
//     const year = now.getFullYear();
//     const month = String(now.getMonth() + 1).padStart(2, '0');
//     const day = String(now.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   });

//   const showSnackbar = (message, severity = "info") => {
//     setSnackbarMessage(message);
//     setSnackbarSeverity(severity);
//     setSnackbarOpen(true);
//   };

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   // Auto-refresh appointments every 1 minute when modal is open
//   useEffect(() => {
//     let intervalId;

//     if (isModalOpen && selectedSlotId) {
//       // Refresh immediately when modal opens
//       handleRefreshAppointments();

//       // Set up interval for auto-refresh every 1 minute
//       intervalId = setInterval(() => {
//         handleRefreshAppointments();
//       }, 30000); // 60 seconds = 1 minute

//       showSnackbar("Auto-refresh enabled - updating every minute", "info");
//     }

//     // Cleanup interval on modal close or component unmount
//     return () => {
//       if (intervalId) {
//         clearInterval(intervalId);
//         console.log("Auto-refresh interval cleared");
//       }
//     };
//   }, [isModalOpen, selectedSlotId]);

//   const fetchTimeslotsByDate = async () => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/Timeslot/active-timeslots?date=${selectedDate}`
//       );
//       setTimeslots(response.data);
//       setError(null);
//     } catch (error) {
//       setTimeslots([]);
//       setError("No timeslots available for the selected date.");
//       console.error("Error fetching timeslots:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (selectedDate) {
//       fetchTimeslotsByDate();
//     }
//   }, [selectedDate]);

//   const handleViewAppointments = async (slotId) => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/appointments/${slotId}`
//       );
//       setAppointments(response.data);
//       setSelectedSlotId(slotId);
//       setIsModalOpen(true);
//       showSnackbar(`Loaded ${response.data.length} appointments`, "success");
//     } catch (error) {
//       console.error("Error fetching appointments:", error);
//       showSnackbar("No appointments available for this timeslot", "info");
//       setAppointments([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Manual refresh function
//   const handleRefreshAppointments = async () => {
//     if (!selectedSlotId) return;
    
//     try {
//       console.log("Refreshing appointments...");
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/appointments/${selectedSlotId}`
//       );
//       setAppointments(response.data);
//       console.log(`Refreshed ${response.data.length} appointments`);
//     } catch (error) {
//       console.error("Error refreshing appointments:", error);
//       showSnackbar("Failed to refresh appointments", "error");
//     }
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedSlotId(null);
//     setSearchTerm("");
//   };

//   const handleStatusUpdate = async (appointment) => {
//     try {
//       const patientCode = appointment.MAD_PATIENT_CODE;
//       const appointmentID = appointment.MAD_APPOINMENT_ID;
      
//       console.log('Updating status with:', { patientCode, appointmentID });  
//       const response = await axios.put(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/status/${appointmentID}`,
//         JSON.stringify("c"), 
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       if (response.status === 200) {
//         console.log('Status updated successfully');
//         showSnackbar("Status updated to completed", "success");
        
//         // Refresh the appointments data
//         handleRefreshAppointments();
//       }
//     } catch (error) {
//       console.error('Error updating status:', error);
//       showSnackbar("Failed to update status", "error");
//     }
//   };

//   const handleAddRecord = (patientId, appointmentID, patientNo) => {
//     navigate(`/dashboard/addrecord/${patientId}`, {
//       state: { appointmentid: appointmentID, channelnumber: patientNo, MTD_APPOINMENT_ID: appointmentID },
//     });
//   };

//   const handlePrintAppointment = (appointmentId, patientCode, patientName, allocatedTime, patientNo) => {
//     const printWindow = window.open('', '_blank');
    
//     const formattedTime = formatTime(allocatedTime);
//     const currentDate = new Date().toLocaleDateString('en-LK');
//     const currentTime = new Date().toLocaleTimeString('en-LK', { 
//       hour: '2-digit', 
//       minute: '2-digit',
//       hour12: false 
//     });

//     printWindow.document.write(`
//       <html>
//         <head>
//           <title>Appointment Details - ${appointmentId}</title>
//           <style>
//             * {
//               margin: 0;
//               padding: 0;
//               box-sizing: border-box;
//             }
            
//             body { 
//               font-family: Arial, sans-serif; 
//               margin: 0;
//               padding: 5px;
//               background: #ffffff;
//               color: #000000;
//               line-height: 1.2;
//               font-size: 10px;
//             }
            
//             .print-container {
//               width: 100%;
//               max-width: 200px;
//               margin: 0 auto;
//               border: 1px solid #000000;
//               border-radius: 3px;
//               padding: 8px;
//               background: #ffffff;
//             }
            
//             .header {
//               text-align: center;
//               margin-bottom: 8px;
//               padding-bottom: 5px;
//               border-bottom: 1px solid #000000;
//             }
            
//             .clinic-name {
//               font-size: 21px;
//               font-weight: bold;
//               color: #000000;
//               margin-bottom: 2px;
//             }
            
//             .document-title {
//               font-size: 18px;
//               font-weight: bold;
//               color: #000000;
//             }
            
//             .main-info {
//               margin: 8px 0;
//               padding: 6px;
//               border: 2px solid #000000;
//               border-radius: 3px;
//               background: #ffff00;
//               text-align: center;
//             }
            
//             .info-label {
//               font-size: 18px;
//               font-weight: bold;
//               color: #000000;
//               margin-bottom: 3px;
//             }
            
//             .info-value {
//               font-size: 36px;
//               font-weight: bold;
//               color: #000000;
//               margin: 4px 0;
//             }
            
//             .patient-info {
//               background: #ffffff;
//               padding: 6px;
//               border: 1px solid #000000;
//               border-radius: 2px;
//               margin: 8px 0;
//             }
            
//             .detail-row {
//               display: flex;
//               justify-content: space-between;
//               margin-bottom: 3px;
//               font-size: 18px;
//             }
            
//             .detail-label {
//               font-weight: bold;
//               color: #000000;
//             }
            
//             .detail-value {
//               font-weight: normal;
//               color: #000000;
//               text-align: right;
//             }
            
//             .arrival-notice {
//               background: #000000;
//               color: #ffffff;
//               padding: 6px;
//               border-radius: 4px;
//               margin: 10px 0 0 0;
//               text-align: center;
//               font-weight: bold;
//               font-size: 18px;
//             }
            
//             @media print {
//               body { 
//                 margin: 0;
//                 padding: 3px;
//               }
//               .print-container {
//                 border: 1px solid #000000 !important;
//                 box-shadow: none !important;
//                 margin: 0 !important;
//                 max-width: 100% !important;
//                 transform: scale(0.9);
//               }
//               .no-print { display: none !important; }
//             }
//           </style>
//         </head>
//         <body>
//           <div class="print-container">
//             <div class="header">
//               <div class="clinic-name">Aura Meditation Center</div>
//               <div class="document-title">APPOINTMENT CONFIRMATION</div>
//             </div>
            
//             <div class="main-info">         
//               <div class="info-label">APPOINTMENT NUMBER</div>
//               <div class="info-value">${patientNo}</div>
//             </div>
            
//             <div class="patient-info">
//               <div class="detail-row">
//                 <span class="detail-label">Name:</span>
//                 <span class="detail-value">${patientName}</span>
//               </div>
//               <div class="detail-row">
//                 <span class="detail-label">Time:</span>
//                 <span class="detail-value">${formattedTime}</span>
//               </div>
//               <div class="detail-row">
//                 <span class="detail-label">Date:</span>
//                 <span class="detail-value">${currentDate}</span>
//               </div>
//             </div>

//             <div class="arrival-notice">
//               MAXIMUM TIME 30 MINUTES
//             </div>
//           </div>

//           <script>
//             window.onload = function() {
//               window.print();
//               setTimeout(function() {
//                 window.close();
//               }, 500);
//             };
//           </script>
//         </body>
//       </html>
//     `);
//     printWindow.document.close();
    
//     showSnackbar("Opening print preview...", "info");
//   };

//   // New function for QZ Tray thermal printing
//   const handleQZTrayPrint = (appointment) => {
//     setSelectedAppointment(appointment);
//     setQzTrayDialogOpen(true);
//   };

//   const handleDateChange = (e) => {
//     setSelectedDate(e.target.value);
//     setAppointments([]);
//     setSelectedSlotId(null);
//   };

//   const formatTime = (timeString) => {
//     return new Date(`1970-01-01T${timeString}`).toLocaleTimeString("en-LK", {
//       hour: "numeric",
//       minute: "numeric",
//       hour12: true,
//     });
//   };

//   const handleCancelAppointment = async (appointmentId) => {
//     try {
//       setIsLoading(true);
//       await axios.delete(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/cancel-appointment/${appointmentId}`
//       );

//       setAppointments(appointments.map(appt =>
//         appt.MAD_APPOINMENT_ID === appointmentId
//           ? { ...appt, MAD_STATUS: "I" }
//           : appt
//       ));

//       showSnackbar("Appointment cancelled successfully", "success");
//     } catch (error) {
//       console.error("Error cancelling appointment:", error);
//       showSnackbar("Failed to cancel appointment", "error");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <Container maxWidth="xl" sx={{ py: 3 }}>
//       <Paper elevation={3} sx={{ p: 4 }}>
//         <Box
//           sx={{
//             mb: 4,
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//           }}
//         >
//           <Typography
//             variant="h4"
//             component="h1"
//             gutterBottom
//             color="primary"
//             fontWeight={600}
//             align="center"
//           >
//             Daily Appointments
//           </Typography>

        
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: isMobile ? "column" : "row",
//               gap: 2,
//               mb: 3,
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             <TextField
//               type="date"
//               label="Select Date"
//               value={selectedDate}
//               onChange={handleDateChange}
//               InputLabelProps={{ shrink: true }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <DateRangeIcon sx={{ color: "primary.main" }} />
//                   </InputAdornment>
//                 ),
//               }}
//               inputProps={{
//                 placeholder: "YYYY/MM/DD"
//               }}
//               sx={{
//                 minWidth: isMobile ? "100%" : 250,
//                 '& .MuiInputBase-input': {
//                   position: 'relative',
//                   backgroundColor: 'transparent',
//                 },
//                 '& input[type="date"]': {
//                   color: 'transparent',
//                   position: 'relative',
//                   '&::-webkit-calendar-picker-indicator': {
//                     opacity: 0,
//                     position: 'absolute',
//                     left: 0,
//                     top: 0,
//                     width: '100%',
//                     height: '100%',
//                     cursor: 'pointer',
//                     zIndex: 2,
//                   },
//                 },
//                 '& .MuiInputBase-root': {
//                   position: 'relative',
//                   '&::after': {
//                     content: selectedDate
//                       ? `"${selectedDate.split('-').join('/')}"`
//                       : '"YYYY/MM/DD"',
//                     position: 'absolute',
//                     left: '40px',
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     color: selectedDate ? 'rgba(0, 0, 0, 0.87)' : 'rgba(0, 0, 0, 0.6)',
//                     fontSize: '14px',
//                     fontFamily: 'inherit',
//                     pointerEvents: 'none',
//                     zIndex: 1,
//                   }
//                 }
//               }}
//             />
//           </Box>
//         </Box>

//         {isLoading && !selectedSlotId ? (
//           <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//             <CircularProgress />
//           </Box>
//         ) : error ? (
//           <Paper elevation={3} sx={{ p: 3, textAlign: "center" }}>
//             <Typography variant="h6" color="textSecondary">
//               {error}
//             </Typography>
//           </Paper>
//         ) : (
//           <Grid container spacing={3}>
//             <Grid item xs={12}>
//               <Typography
//                 variant="h6"
//                 gutterBottom
//                 color="primary"
//                 fontWeight={600}
//               >
//                 Available Timeslots
//               </Typography>
//               <Grid container spacing={2}>
//                 {timeslots.map((timeslot) => (
//                   <Grid item xs={12} key={timeslot.MT_SLOT_ID}>
//                     <Card
//                       elevation={3}
//                       sx={{
//                         borderLeft:
//                           selectedSlotId === timeslot.MT_SLOT_ID
//                             ? `4px solid ${theme.palette.primary.main}`
//                             : "none",
//                         cursor: "pointer",
//                         "&:hover": {
//                           boxShadow: 4,
//                         },
//                       }}
//                       onClick={() =>
//                         handleViewAppointments(timeslot.MT_SLOT_ID)
//                       }
//                     >
//                       <CardContent>
//                         <Box
//                           sx={{ display: "flex", alignItems: "center", mb: 1 }}
//                         >
//                           <Avatar
//                             sx={{ bgcolor: theme.palette.primary.main, mr: 2 }}
//                           >
//                             <PersonIcon />
//                           </Avatar>
//                           <Typography variant="subtitle1">
//                             {timeslot.MT_DOCTOR}
//                           </Typography>
//                         </Box>
//                         <Box sx={{ display: "flex", alignItems: "center" }}>
//                           <TimeIcon color="action" sx={{ mr: 1 }} />
//                           <Typography>
//                             {formatTime(timeslot.MT_START_TIME)} -{" "}
//                             {formatTime(timeslot.MT_END_TIME)}
//                           </Typography>
//                         </Box>
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 ))}
//               </Grid>
//             </Grid>
//           </Grid>
//         )}

//         {/* Responsive Appointments Modal */}
//         <AppointmentsModal
//           open={isModalOpen}
//           onClose={handleCloseModal}
//           appointments={appointments}
//           searchTerm={searchTerm}
//           onSearchChange={(e) => setSearchTerm(e.target.value)}
//           isLoading={isLoading}
//           onStatusUpdate={handleStatusUpdate}
//           onAddRecord={handleAddRecord}
//           onCancelAppointment={handleCancelAppointment}
//           onQZTrayPrint={handleQZTrayPrint}
//           selectedSlotId={selectedSlotId}
//           onRefresh={handleRefreshAppointments}
//         />

//         {/* QZ Tray Thermal Printing Dialog */}
//         <QZTrayAppointmentPrint
//           open={qzTrayDialogOpen}
//           onClose={() => setQzTrayDialogOpen(false)}
//           appointment={selectedAppointment}
//         />

//         <Snackbar
//           open={snackbarOpen}
//           autoHideDuration={6000}
//           onClose={handleSnackbarClose}
//           anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         >
//           <Alert
//             onClose={handleSnackbarClose}
//             severity={snackbarSeverity}
//             sx={{ width: "100%" }}
//           >
//             {snackbarMessage}
//           </Alert>
//         </Snackbar>
//       </Paper>
//     </Container>
//   );
// }


//working test 

import { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Chip,
  useTheme,
  useMediaQuery,
  Avatar,
  Divider,
  Snackbar,
  Alert,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Drawer,
  MenuItem,
  FormControl,
  Select,
} from "@mui/material";
import {
  DateRange as DateRangeIcon,
  AccessTime as TimeIcon,
  Person as PersonIcon,
  Add as AddIcon,
  CheckCircle as CheckCircleIcon,
  Pending as PendingIcon,
  Search as SearchIcon,
  Refresh as RefreshIcon,
  Close as CloseIcon,
  Print as PrintIcon,
  Usb as UsbIcon,
  CloudUpload as CloudUploadIcon,
  AutoAwesome as AutoAwesomeIcon,
  Download as DownloadIcon,
} from "@mui/icons-material";
import auraBmpLogo from "../assets/AuraLogo.bmp";

// Enhanced Thermal Print Component with BMP Logo Support
const ThermalPrintDialog = ({ 
  open, 
  onClose, 
  appointment 
}) => {
  const [isPrinting, setIsPrinting] = useState(false);
  const [printMethod, setPrintMethod] = useState('browser');
  const [status, setStatus] = useState('');

  // Use the directly imported BMP logo
  const logoSource = auraBmpLogo;

  // Safe patient name display
  const getPatientName = () => {
    if (!appointment) return 'N/A';
    
    const name = appointment.MAD_FULL_NAME || 
                 appointment.patientName || 
                 appointment.name || 
                 'Unknown Patient';
    
    return String(name).trim() || 'Unknown Patient';
  };

  const getPatientNumber = () => {
    if (!appointment) return 'N/A';
    
    const patientNo = appointment.MAD_PATIENT_NO || 
                     appointment.patientNo || 
                     appointment.channelNumber || 
                     'N/A';
    
    return String(patientNo).trim() || 'N/A';
  };

  const formatTime = (timeString) => {
    if (!timeString) return 'N/A';
    
    try {
      return new Date(`1970-01-01T${timeString}`).toLocaleTimeString("en-LK", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });
    } catch (error) {
      console.error('Error formatting time:', error);
      return 'Invalid Time';
    }
  };

  // Generate ESC/POS commands for thermal printers
  const generateEscPosCommands = () => {
    const currentDate = new Date().toLocaleDateString('en-LK');
    const currentTime = new Date().toLocaleTimeString('en-LK', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });

    // ESC/POS commands
    const commands = [
      '\x1B\x40', // Initialize printer
      '\x1B\x61\x01', // Center alignment
      '\x1B\x21\x30', // Double height and width
      'AURA MEDITATION CENTER\n',
      '\x1B\x21\x00', // Normal text
      '\x1B\x61\x00', // Left alignment
      '================================\n',
      '\x1B\x61\x01', // Center alignment
      '\x1B\x45\x01', // Bold on
      'APPOINTMENT CONFIRMATION\n',
      '\x1B\x45\x00', // Bold off
      '================================\n',
      '\x1B\x61\x01', // Center alignment
      '\x1B\x45\x01', // Bold on
      `${getPatientName()}\n`,
      '\x1B\x45\x00', // Bold off
      '================================\n',
      '\x1B\x61\x01', // Center alignment
      '\x1B\x21\x30', // Double height and width
      'APPOINMENT NUMBER\n',
      `${getPatientNumber()}\n`,
      '\x1B\x21\x00', // Normal text
      '\n',
      '================================\n',
      '\x1B\x61\x01', // Center alignment
      '\x1B\x21\x38', // Triple height and width - LARGEST SIZE
      '\x1B\x45\x01', // Bold on
      'MAXIMUM TIME 30 MINUTES \n',
      '\x1B\x45\x00', // Bold off
      '\x1B\x21\x00', // Normal text - Back to normal size
      '\n\n\n\n',
      '\x1D\x56\x41\x03' // Cut paper
    ];

    return commands.join('');
  };

  // Method 1: Browser Print with BMP Logo and Thermal Printer CSS
  const handleBrowserPrint = () => {
    setIsPrinting(true);
    setStatus('Preparing print with BMP logo...');

    const printContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Appointment Receipt - Aura Meditation Center</title>
        <style>
          @media print {
            @page {
              margin: 0;
              size: 80mm 150mm;
              margin: 2mm;
            }
            
            body {
              margin: 0;
              padding: 2mm;
              font-family: 'Courier New', monospace;
              font-size: 10px;
              line-height: 1.2;
              width: 76mm;
              background: white;
              color: black;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            
            .receipt {
              width: 76mm;
              margin: 0 auto;
            }
            
            .header {
              text-align: center;
              margin-bottom: 3px;
            }
            
            .center {
              text-align: center;
            }
            
            .bold {
              font-weight: bold;
            }
            
            .large {
              font-size: 14px;
              font-weight: bold;
            }
            
            .x-large {
              font-size: 16px;
              font-weight: bold;
            }
            
            .xx-large {
              font-size: 18px;
              font-weight: bold;
            }
            
            .divider {
              border-bottom: 2px solid #000;
              margin: 3px 0;
              height: 2px;
            }
            
            .double-divider {
              border-bottom: 3px solid #000;
              margin: 4px 0;
              height: 3px;
            }
            
            .channel-number {
              text-align: center;
              margin: 8px 0;
              padding: 5px;
              border: 3px solid #000;
              background: #f0f0f0;
            }
            
            .maximum-time {
              text-align: center;
              font-weight: bold;
              font-size: 18px;
              margin: 8px 0;
              padding: 4px;
              background: #000 !important;
              color: #fff !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
              border: 2px solid #000;
            }
            
            .footer {
              text-align: center;
              margin-top: 10px;
              font-weight: bold;
            }
            
            .logo {
              text-align: center;
              margin-bottom: 5px;
            }
            
            .patient-name {
              text-align: center;
              font-size: 18px;
              font-weight: bold;
              margin: 5px 0;
            }
            
            .timestamp {
              text-align: center;
              font-weight: bold;
              color: #000 !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
              margin-top: 5px;
              font-size: 9px;
            }
            
            /* Enhanced BMP logo styling for dark backgrounds */
            .bmp-logo {
              max-width: 35mm;
              height: auto;
              display: block;
              margin: 0 auto 3px auto;
              filter: invert(1) brightness(2) contrast(1000%) saturate(0%);
              -webkit-filter: invert(1) brightness(2) contrast(1000%) saturate(0%);
              image-rendering: pixelated;
              image-rendering: -webkit-optimize-contrast;
            }
            
            /* Alternative filter for better visibility */
            .bmp-logo-alt {
              max-width: 35mm;
              height: auto;
              display: block;
              margin: 0 auto 3px auto;
              filter: brightness(0) invert(1) contrast(1000%);
              -webkit-filter: brightness(0) invert(1) contrast(1000%);
            }
            
            /* Simple black and white conversion */
            .bmp-logo-simple {
              max-width: 35mm;
              height: auto;
              display: block;
              margin: 0 auto 3px auto;
              filter: grayscale(100%) contrast(1000%) brightness(0%);
              -webkit-filter: grayscale(100%) contrast(1000%) brightness(0%);
            }
            
            .text-left {
              text-align: left;
            }
            
            .text-right {
              text-align: right;
            }
            
            .row {
              display: flex;
              justify-content: space-between;
              margin: 2px 0;
              border-bottom: 1px solid #333;
              padding-bottom: 1px;
            }

            .header .x-large {
              text-shadow: 0.5px 0.5px 0.5px #000;
            }
            
            .channel-number .x-large {
              text-shadow: 0.5px 0.5px 0.5px #000;
            }
            
            .receipt {
              box-shadow: 0 0 0 1px #000;
            }
          }
          
          @media screen {
            body {
              background: #f5f5f5;
              padding: 20px;
            }
            .receipt {
              border: 2px dashed #666;
              background: white;
              padding: 10px;
            }
          }
        </style>
      </head>
      <body>
        <div class="receipt">
          <!-- BMP Logo Section with multiple filter options -->
          <div class="logo">
            <img src="${logoSource}" alt="Aura Meditation Center" class="bmp-logo">
          </div>
          
          <div class="header">
            <div class="x-large">AURA MEDITATION CENTER</div>
            <div class="double-divider"></div>
            <div class="large">APPOINTMENT CONFIRMATION</div>
            <div class="double-divider"></div>
          </div>
          
          <!-- Centered Patient Name -->
          <div class="patient-name">
            ${getPatientName()}
          </div>
          
          <div class="divider"></div>
          
          <div class="channel-number">
            <div class="x-large">APPOINMENT NUMBER</div>
            <div class="x-large">${getPatientNumber()}</div>
          </div>
          
          <div class="divider"></div>
          
          <!-- Enhanced Maximum Time Section -->
          <div class="maximum-time">
            MAXIMUM TIME 30 MINUTES
          </div>
          
          <div class="footer">
            <div class="bold">THANK YOU!</div>
            <div class="bold">Aura Meditation Center</div>
          </div>
          
          <div class="divider"></div>
          
          <!-- Darker Timestamp -->
          <div class="timestamp">
            <strong>Generated: ${new Date().toLocaleString('en-LK')}</strong>
          </div>
        </div>
        
        <script>
          window.onload = function() {
            setTimeout(function() {
              window.print();
              setTimeout(function() {
                window.close();
              }, 500);
            }, 500);
          };
          
          setTimeout(function() {
            if (!document.hidden) {
              window.print();
              setTimeout(function() {
                window.close();
              }, 500);
            }
          }, 3000);
        </script>
      </body>
      </html>
    `;

    const printWindow = window.open('', '_blank', 'width=400,height=600');
    if (printWindow) {
      printWindow.document.write(printContent);
      printWindow.document.close();
      setStatus('Print dialog opened with BMP logo');
    } else {
      setStatus('Failed to open print window. Please allow popups.');
    }
    
    setTimeout(() => {
      setIsPrinting(false);
      onClose();
    }, 2000);
  };

  // Method 2: Download ESC/POS file for manual transfer
  const handleDownloadEscPos = () => {
    setIsPrinting(true);
    setStatus('Generating ESC/POS file...');
    
    try {
      const escPosData = generateEscPosCommands();
      
      const blob = new Blob([escPosData], { type: 'application/octet-stream' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `appointment-${getPatientNumber()}.txt`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      
      setStatus('ESC/POS file downloaded. Transfer to printer manually.');
      setTimeout(() => {
        setIsPrinting(false);
        onClose();
      }, 2000);
    } catch (error) {
      setStatus('Error generating file: ' + error.message);
      setIsPrinting(false);
    }
  };

  // Method 3: Server-side printing
  const handleServerPrint = async () => {
    setIsPrinting(true);
    setStatus('Sending to server printer...');
    
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/print/appointment`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          appointment,
          type: 'thermal',
          timestamp: new Date().toISOString()
        }),
      });
      
      if (response.ok) {
        const result = await response.json();
        setStatus('Print job sent to server successfully!');
        setTimeout(() => {
          setIsPrinting(false);
          onClose();
        }, 1500);
      } else {
        throw new Error('Server returned error: ' + response.status);
      }
    } catch (error) {
      setStatus('Server printing failed: ' + error.message);
      setTimeout(() => {
        setStatus('Falling back to browser print...');
        handleBrowserPrint();
      }, 1500);
    }
  };

  // Method 4: Image-based print with BMP logo
  const handleImagePrint = () => {
    setIsPrinting(true);
    setStatus('Generating printable image with BMP logo...');
    
    const printContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Print Receipt</title>
        <style>
          @page { margin: 0; size: 80mm auto; }
          body { 
            margin: 2mm; 
            font-family: Arial, sans-serif;
            font-size: 9px;
            line-height: 1.1;
            width: 76mm;
          }
          .container { 
            border: 1px solid #000; 
            padding: 3mm;
            text-align: center;
          }
          .logo-container {
            text-align: center;
            margin-bottom: 2mm;
          }
          .bmp-logo {
            max-width: 30mm;
            height: auto;
            filter: invert(1) brightness(2) contrast(1000%) saturate(0%);
            -webkit-filter: invert(1) brightness(2) contrast(1000%) saturate(0%);
          }
          .header { font-size: 11px; font-weight: bold; margin-bottom: 2mm; }
          .channel { font-size: 14px; font-weight: bold; margin: 3mm 0; border: 2px solid #000; padding: 2mm; }
          .maximum-time { 
            background: #000 !important; 
            color: #fff !important; 
            padding: 3mm; 
            margin: 3mm 0; 
            font-weight: bold;
            text-align: center;
            font-size: 16px;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
            border: 2px solid #000;
          }
          .footer { margin-top: 3mm; font-weight: bold; }
          .patient-name {
            text-align: center;
            font-size: 16px;
            font-weight: bold;
            margin: 3mm 0;
          }
          .timestamp {
            text-align: center;
            font-weight: bold;
            color: #000 !important;
            margin-top: 2mm;
            font-size: 8px;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
        </style>
      </head>
      <body>
        <div class="container">
          <div class="logo-container">
            <img src="${logoSource}" alt="Aura Logo" class="bmp-logo">
          </div>
          <div class="header">AURA MEDITATION CENTER<br>APPOINTMENT CONFIRMATION</div>
          <div style="border-bottom: 1px solid #000; margin: 2mm 0;"></div>
          
          <!-- Centered Patient Name -->
          <div class="patient-name">${getPatientName()}</div>
          
          <div style="text-align: left;">
            <div><strong>Time:</strong> ${formatTime(appointment?.MAD_ALLOCATED_TIME)}</div>
            <div><strong>Contact:</strong> ${appointment?.MAD_CONTACT || 'N/A'}</div>
            <div><strong>Date:</strong> ${new Date().toLocaleDateString('en-LK')}</div>
          </div>
          <div style="border-bottom: 1px solid #000; margin: 2mm 0;"></div>
          <div class="channel">APPOINMENT NUMBER<br>${getPatientNumber()}</div>
          <div style="border-bottom: 1px solid #000; margin: 2mm 0;"></div>
          
          <!-- Enhanced Maximum Time Section -->
          <div class="maximum-time">MAXIMUM TIME 30 MINUTES</div>
          
          <div class="footer">THANK YOU!<br>Aura Meditation Center</div>
          
          <!-- Darker Timestamp -->
          <div class="timestamp"><strong>Printed: ${new Date().toLocaleString('en-LK')}</strong></div>
        </div>
        <script>
          setTimeout(() => window.print(), 500);
          setTimeout(() => window.close(), 2000);
        </script>
      </body>
      </html>
    `;

    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.write(printContent);
      printWindow.document.close();
    }
    
    setTimeout(() => {
      setIsPrinting(false);
      onClose();
    }, 3000);
  };

  const handlePrint = () => {
    switch (printMethod) {
      case 'browser':
        handleBrowserPrint();
        break;
      case 'server':
        handleServerPrint();
        break;
      case 'download':
        handleDownloadEscPos();
        break;
      case 'image':
        handleImagePrint();
        break;
      default:
        handleBrowserPrint();
    }
  };

  const printMethods = [
    {
      id: 'browser',
      name: 'Browser Thermal Print',
      description: 'Optimized for thermal printers with BMP logo',
      icon: <PrintIcon />,
    },
    {
      id: 'image',
      name: 'Simple Print with Logo',
      description: 'Basic printable format with BMP logo',
      icon: <PrintIcon />,
    },
    {
      id: 'download',
      name: 'Download ESC/POS File',
      description: 'Download file for manual transfer to thermal printer',
      icon: <DownloadIcon />,
    },
    {
      id: 'server',
      name: 'Server Print',
      description: 'Send to network/shared printer',
      icon: <CloudUploadIcon />,
    }
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Print Appointment Receipt
        <Chip label="BMP Logo" color="success" size="small" sx={{ ml: 1 }} />
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Select printing method for thermal receipt with BMP logo support
        </Typography>
        
        <FormControl fullWidth sx={{ mb: 3 }}>
          <Select
            value={printMethod}
            onChange={(e) => setPrintMethod(e.target.value)}
            disabled={isPrinting}
          >
            {printMethods.map(method => (
              <MenuItem key={method.id} value={method.id}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  {method.icon}
                  <Box>
                    <Typography variant="body2" fontWeight="bold">
                      {method.name}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {method.description}
                    </Typography>
                  </Box>
                </Box>
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Enhanced Print Preview with BMP Logo */}
        <Card variant="outlined" sx={{ mb: 2 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Receipt Preview with BMP Logo
            </Typography>
            <Paper 
              sx={{ 
                p: 2, 
                backgroundColor: '#f5f5f5', 
                fontFamily: 'Courier New, monospace', 
                fontSize: '10px', 
                lineHeight: '1.2',
                border: '1px dashed #ccc'
              }}
            >
              {/* BMP Logo Preview with enhanced visibility */}
              <Box sx={{ textAlign: 'center', mb: 1 }}>
                <img 
                  src={logoSource} 
                  alt="Aura Logo" 
                  style={{ 
                    maxWidth: '35mm', 
                    height: 'auto',
                    filter: 'invert(1) brightness(2) contrast(1000%) saturate(0%)'
                  }}
                />
              </Box>
              
              <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '12px' }}>
                AURA MEDITATION CENTER
              </div>
              <div style={{ borderBottom: '1px solid #000', margin: '3px 0' }}></div>
              <div style={{ textAlign: 'center', fontWeight: 'bold' }}>APPOINTMENT CONFIRMATION</div>
              <div style={{ borderBottom: '1px solid #000', margin: '3px 0' }}></div>
              
              {/* Centered Patient Name */}
              <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '14px', margin: '8px 0' }}>
                {getPatientName()}
              </div>
              
              <div style={{ borderBottom: '1px solid #000', margin: '3px 0' }}></div>
              <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '14px', margin: '5px 0' }}>
                APPOINMENT NUMBER<br/>
                {getPatientNumber()}
              </div>
              <div style={{ borderBottom: '1px solid #000', margin: '3px 0' }}></div>
              
              {/* Enhanced Maximum Time Section */}
              <div style={{ 
                textAlign: 'center', 
                fontWeight: 'bold', 
                fontSize: '16px', 
                margin: '8px 0',
                padding: '4px',
                backgroundColor: '#000',
                color: '#fff',
                border: '2px solid #000'
              }}>
                MAXIMUM TIME 30 MINUTES
              </div>
              
              <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
                THANK YOU!<br/>Aura Meditation Center
              </div>
              
              {/* Darker Timestamp */}
              <div style={{ textAlign: 'center', marginTop: '8px', fontWeight: 'bold', color: '#000', fontSize: '9px' }}>
                Generated: {new Date().toLocaleString('en-LK')}
              </div>
            </Paper>
            
            {/* Filter options for testing */}
            <Box sx={{ mt: 2, p: 1, backgroundColor: '#f8f8f8', borderRadius: 1 }}>
              <Typography variant="caption" color="text.secondary">
                <strong>Logo Visibility Options:</strong> If the logo appears too dark, try different filter combinations:
              </Typography>
              <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                <Typography variant="caption">
                  • <strong>Current:</strong> invert(1) brightness(2) contrast(1000%)
                </Typography>
                <Typography variant="caption">
                  • <strong>Alternative 1:</strong> brightness(0) invert(1) contrast(1000%)
                </Typography>
                <Typography variant="caption">
                  • <strong>Alternative 2:</strong> grayscale(100%) contrast(1000%) brightness(0%)
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>

        {status && (
          <Alert severity="info" sx={{ mb: 2 }}>
            {status}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isPrinting}>
          Cancel
        </Button>
        <Button 
          onClick={handlePrint}
          variant="contained"
          disabled={isPrinting}
          startIcon={isPrinting ? <CircularProgress size={16} /> : <PrintIcon />}
        >
          {isPrinting ? 'Printing...' : 'Print Receipt'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// Universal Printing Component (Simplified)
const UniversalPrintDialog = ({ 
  open, 
  onClose, 
  appointment,
  onThermalPrint
}) => {
  const [isPrinting, setIsPrinting] = useState(false);

  const handleQuickPrint = () => {
    onClose();
    onThermalPrint();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Print Options
        <Chip label="BMP Logo" color="success" size="small" sx={{ ml: 1 }} />
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Choose how to print the appointment receipt with BMP logo support
        </Typography>
        
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card 
              variant="outlined" 
              sx={{ cursor: 'pointer', '&:hover': { backgroundColor: 'action.hover' } }}
              onClick={handleQuickPrint}
            >
              <CardContent>
                <Box display="flex" alignItems="center" gap={2}>
                  <PrintIcon color="primary" />
                  <Box>
                    <Typography variant="h6">
                      Thermal Receipt Print
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Optimized for thermal printers with BMP logo and multiple format options
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// Enhanced AppointmentsModal with better patient name handling
const AppointmentsModal = ({ 
  open, 
  onClose, 
  appointments, 
  searchTerm, 
  onSearchChange, 
  isLoading, 
  onStatusUpdate, 
  onAddRecord, 
  onCancelAppointment, 
  onPrintAppointment,
  selectedSlotId,
  onRefresh
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Safe patient name extraction
  const getPatientName = (appointment) => {
    if (!appointment) return 'Unknown Patient';
    
    const name = appointment.MAD_FULL_NAME || 
                 appointment.patientName || 
                 appointment.name || 
                 'Unknown Patient';
    
    return String(name).trim() || 'Unknown Patient';
  };

  const getPatientInitial = (appointment) => {
    const name = getPatientName(appointment);
    return name.charAt(0).toUpperCase();
  };

  const filteredAppointments = appointments.filter((appointment) =>
    getPatientName(appointment).toLowerCase().includes(searchTerm.toLowerCase()) ||
    (appointment.MAD_CONTACT && appointment.MAD_CONTACT.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const formatTime = (timeString) => {
    if (!timeString) return 'N/A';
    
    try {
      return new Date(`1970-01-01T${timeString}`).toLocaleTimeString("en-LK", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });
    } catch (error) {
      console.error('Error formatting time:', error);
      return 'Invalid Time';
    }
  };

  // Mobile drawer content
  const mobileContent = (
    <Box sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" fontWeight="bold" color="primary">
          Appointments
        </Typography>
        <Box>
          <IconButton onClick={onRefresh} size="small" color="primary">
            <RefreshIcon />
          </IconButton>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>

      <TextField
        size="small"
        fullWidth
        placeholder="Search patients..."
        value={searchTerm}
        onChange={onSearchChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="primary" />
            </InputAdornment>
          ),
        }}
        sx={{ mb: 2 }}
      />

      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      ) : filteredAppointments.length === 0 ? (
        <Typography variant="body1" color="textSecondary" sx={{ textAlign: "center", py: 4 }}>
          {searchTerm ? 'No patients found matching your search' : 'No appointments found for this timeslot'}
        </Typography>
      ) : (
        <Box sx={{ maxHeight: '70vh', overflow: 'auto' }}>
          {filteredAppointments.map((appointment) => (
            <Card 
              key={appointment.MAD_APPOINMENT_ID} 
              sx={{ 
                mb: 2, 
                opacity: appointment.MAD_STATUS === "I" ? 0.6 : 1,
                backgroundColor: appointment.MAD_STATUS === "I" ? '#ffe6e6' : 'inherit'
              }}
            >
              <CardContent sx={{ p: 2 }}>
                {/* Patient Header */}
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Avatar sx={{ width: 40, height: 40, mr: 2 }}>
                    {getPatientInitial(appointment)}
                  </Avatar>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {getPatientName(appointment)}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {appointment.MAD_CONTACT || 'No contact info'}
                    </Typography>
                  </Box>
                  <Chip
                    label={appointment.MAD_PATIENT_NO || 'N/A'}
                    color="primary"
                    size="small"
                  />
                </Box>

                <Divider sx={{ my: 1 }} />

                {/* Appointment Details */}
                <Box sx={{ mb: 2 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="body2" color="text.secondary">Time:</Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {formatTime(appointment.MAD_ALLOCATED_TIME)}
                    </Typography>
                  </Box>
                  
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="body2" color="text.secondary">Status:</Typography>
                    {appointment.MAD_STATUS === "I" ? (
                      <Chip label="Cancelled" color="error" size="small" />
                    ) : appointment.MAD_STATUS === "c" ? (
                      <Chip
                        icon={<CheckCircleIcon fontSize="small" />}
                        label="Completed"
                        color="success"
                        size="small"
                      />
                    ) : appointment.TreatmentStatus === "C" ? (
                      <Chip
                        icon={<CheckCircleIcon fontSize="small" />}
                        label="Completed"
                        color="success"
                        size="small"
                      />
                    ) : appointment.TreatmentStatus === "P" ? (
                      <Chip
                        icon={<CheckCircleIcon fontSize="small" />}
                        label="Preparation Complete"
                        color="info"
                        size="small"
                        clickable
                        onClick={() => onStatusUpdate(appointment)}
                      />
                    ) : (
                      <Chip
                        icon={<PendingIcon fontSize="small" />}
                        label="Pending"
                        color="warning"
                        size="small"
                        clickable
                        onClick={() => onStatusUpdate(appointment)}
                      />
                    )}
                  </Box>
                </Box>

                <Divider sx={{ my: 1 }} />

                {/* Action Buttons */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Button
                    variant="outlined"
                    size="small"
                    fullWidth
                    startIcon={<AddIcon />}
                    onClick={() => {
                      onAddRecord(
                        appointment.MAD_PATIENT_CODE,
                        appointment.MAD_APPOINMENT_ID,
                        appointment.MAD_PATIENT_NO
                      );
                      onClose();
                    }}
                    disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
                  >
                    Add Treatment
                  </Button>
                  
                  <Button
                    variant="outlined"
                    size="small"
                    color="error"
                    fullWidth
                    startIcon={<CloseIcon />}
                    onClick={() => onCancelAppointment(appointment.MAD_APPOINMENT_ID)}
                    disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
                  >
                    Cancel Appointment
                  </Button>
                  
                  <Button
                    variant="contained"
                    size="small"
                    color="secondary"
                    fullWidth
                    startIcon={<PrintIcon />}
                    onClick={() => onPrintAppointment(appointment)}
                  >
                    Print Receipt
                  </Button>
                </Box>
              </CardContent>
            </Card>
          ))}
        </Box>
      )}
    </Box>
  );

  // Desktop table content
  const desktopContent = (
    <>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h5" component="h2" fontWeight="bold" color="primary">
            Appointments ({filteredAppointments.length})
          </Typography>
          <Box display="flex" alignItems="center" gap={1}>
            <Button
              startIcon={<RefreshIcon />}
              onClick={onRefresh}
              size="small"
              variant="outlined"
            >
              Refresh
            </Button>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      
      <DialogContent dividers>
        <Box sx={{ mb: 2 }}>
          <TextField
            size="small"
            fullWidth
            placeholder="Search patients by name or contact..."
            value={searchTerm}
            onChange={onSearchChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" sx={{ color: "primary.main" }}>
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : filteredAppointments.length === 0 ? (
          <Typography variant="body1" color="textSecondary" sx={{ textAlign: "center", py: 4 }}>
            {searchTerm ? 'No patients found matching your search' : 'No appointments found for this timeslot'}
          </Typography>
        ) : (
          <TableContainer>
            <Table size="medium">
              <TableHead sx={{ backgroundColor: theme.palette.primary.light }}>
                <TableRow>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Patient</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Contact</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Time</TableCell>
                  <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>No.</TableCell>
                  <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>Status</TableCell>
                  <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredAppointments.map((appointment) => (
                  <TableRow
                    key={appointment.MAD_APPOINMENT_ID}
                    hover
                    sx={{
                      opacity: appointment.MAD_STATUS === "I" ? 0.6 : 1,
                      backgroundColor: appointment.MAD_STATUS === "I" ? '#ffe6e6' : 'inherit'
                    }}
                  >
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Avatar sx={{ width: 32, height: 32, mr: 1 }}>
                          {getPatientInitial(appointment)}
                        </Avatar>
                        {getPatientName(appointment)}
                      </Box>
                    </TableCell>
                    <TableCell>{appointment.MAD_CONTACT || 'N/A'}</TableCell>
                    <TableCell>
                      {formatTime(appointment.MAD_ALLOCATED_TIME)}
                    </TableCell>
                    <TableCell align="center">
                      <Chip
                        label={appointment.MAD_PATIENT_NO || 'N/A'}
                        color="primary"
                        size="small"
                      />
                    </TableCell>
                   
                    <TableCell align="center">
                      {appointment.MAD_STATUS === "I" ? (
                        <Chip
                          label="Cancelled"
                          color="error"
                          size="small"
                        />
                      ) : appointment.MAD_STATUS === "c" ? (
                          <Chip
                            icon={<CheckCircleIcon fontSize="small" />}
                            label="Completed"
                            color="success"
                            size="small"
                          />
                        ): appointment.TreatmentStatus === "C" ? (
                        <Chip
                          icon={<CheckCircleIcon fontSize="small" />}
                          label="Completed"
                          color="success"
                          size="small"
                        />
                      ) : appointment.TreatmentStatus === "P" ? (
                        <Chip
                          icon={<CheckCircleIcon fontSize="small" />}
                          label="Preparation Complete"
                          color="info"
                          size="small"
                          clickable
                          onClick={() => onStatusUpdate(appointment)}
                        />
                      ) : (
                        <Chip
                          icon={<PendingIcon fontSize="small" />}
                          label="Pending"
                          color="warning"
                          size="small"
                          clickable
                          onClick={() => onStatusUpdate(appointment)}
                        />
                      )}
                    </TableCell>
                    <TableCell align="center" sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<AddIcon />}
                        onClick={() => {
                          onAddRecord(
                            appointment.MAD_PATIENT_CODE,
                            appointment.MAD_APPOINMENT_ID,
                            appointment.MAD_PATIENT_NO
                          );
                          onClose();
                        }}
                        disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
                      >
                        Add Treatment
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        color="error"
                        startIcon={<CloseIcon />}
                        onClick={() => onCancelAppointment(appointment.MAD_APPOINMENT_ID)}
                        disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
                      >
                        Cancel
                      </Button>
                      
                      <Button
                        variant="contained"
                        size="small"
                        color="secondary"
                        startIcon={<PrintIcon />}
                        onClick={() => onPrintAppointment(appointment)}
                      >
                        Receipt
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
    </>
  );

  if (isMobile) {
    return (
      <Drawer
        anchor="bottom"
        open={open}
        onClose={onClose}
        sx={{
          '& .MuiDrawer-paper': {
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            maxHeight: '90vh',
          },
        }}
      >
        {mobileContent}
      </Drawer>
    );
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
    >
      {desktopContent}
    </Dialog>
  );
};

// Main Component
export default function DailyAppointment() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  const [timeslots, setTimeslots] = useState([]);
  const [error, setError] = useState(null);
  const [appointments, setAppointments] = useState([]);
  const [selectedSlotId, setSelectedSlotId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("info");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [universalPrintDialogOpen, setUniversalPrintDialogOpen] = useState(false);
  const [thermalPrintDialogOpen, setThermalPrintDialogOpen] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [selectedDate, setSelectedDate] = useState(() => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  });

  const showSnackbar = (message, severity = "info") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  // Auto-refresh appointments every 1 minute when modal is open
  useEffect(() => {
    let intervalId;

    if (isModalOpen && selectedSlotId) {
      // Refresh immediately when modal opens
      handleRefreshAppointments();

      // Set up interval for auto-refresh every 1 minute
      intervalId = setInterval(() => {
        handleRefreshAppointments();
      }, 60000); // 60 seconds = 1 minute

      showSnackbar("Auto-refresh enabled - updating every minute", "info");
    }

    // Cleanup interval on modal close or component unmount
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
        console.log("Auto-refresh interval cleared");
      }
    };
  }, [isModalOpen, selectedSlotId]);

  const fetchTimeslotsByDate = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/Timeslot/active-timeslots?date=${selectedDate}`
      );
      setTimeslots(response.data);
      setError(null);
    } catch (error) {
      setTimeslots([]);
      setError("No timeslots available for the selected date.");
      console.error("Error fetching timeslots:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedDate) {
      fetchTimeslotsByDate();
    }
  }, [selectedDate]);

  const handleViewAppointments = async (slotId) => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/Appointment/appointments/${slotId}`
      );
      setAppointments(response.data);
      setSelectedSlotId(slotId);
      setIsModalOpen(true);
      showSnackbar(`Loaded ${response.data.length} appointments`, "success");
    } catch (error) {
      console.error("Error fetching appointments:", error);
      showSnackbar("No appointments available for this timeslot", "info");
      setAppointments([]);
    } finally {
      setIsLoading(false);
    }
  };

  // Manual refresh function
  const handleRefreshAppointments = async () => {
    if (!selectedSlotId) return;
    
    try {
      console.log("Refreshing appointments...");
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/Appointment/appointments/${selectedSlotId}`
      );
      setAppointments(response.data);
      console.log(`Refreshed ${response.data.length} appointments`);
    } catch (error) {
      console.error("Error refreshing appointments:", error);
      showSnackbar("Failed to refresh appointments", "error");
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedSlotId(null);
    setSearchTerm("");
  };

  const handleStatusUpdate = async (appointment) => {
  try {
    const patientCode = appointment.MAD_PATIENT_CODE;
    const appointmentID = appointment.MAD_APPOINMENT_ID;
    const phoneNumber = appointment.MAD_CONTACT; // Get phone number from appointment

    console.log('Updating status with:', { patientCode, appointmentID, phoneNumber });

    // First update the appointment status
    const response = await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/Appointment/status/${appointmentID}`,
      JSON.stringify("c"),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200) {
      console.log('Status updated successfully');
      
      // Send SMS after status is updated to complete
      if (phoneNumber) {
        try {
          const smsResponse = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/Treatment/send-sms`,
            {
              Phone: phoneNumber
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          
          if (smsResponse.status === 200) {
            console.log('SMS sent successfully');
            showSnackbar("Status updated to completed and SMS sent", "success");
          }
        } catch (smsError) {
          console.error('Error sending SMS:', smsError);
          showSnackbar("Status updated but failed to send SMS", "warning");
        }
      } else {
        showSnackbar("Status updated to completed (no phone number for SMS)", "success");
      }

      // Refresh the appointments data
      handleRefreshAppointments();
    }
  } catch (error) {
    console.error('Error updating status:', error);
    showSnackbar("Failed to update status", "error");
  }
};

  const handleAddRecord = (patientId, appointmentID, patientNo) => {
    navigate(`/dashboard/addrecord/${patientId}`, {
      state: { 
        appointmentid: appointmentID, 
        channelnumber: patientNo, 
        MTD_APPOINMENT_ID: appointmentID 
      },
    });
  };

  const handlePrintAppointment = (appointment) => {
    setSelectedAppointment(appointment);
    setUniversalPrintDialogOpen(true);
  };

  const handleThermalPrint = () => {
    setThermalPrintDialogOpen(true);
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
    setAppointments([]);
    setSelectedSlotId(null);
  };

  const formatTime = (timeString) => {
    if (!timeString) return 'N/A';
    
    try {
      return new Date(`1970-01-01T${timeString}`).toLocaleTimeString("en-LK", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });
    } catch (error) {
      console.error('Error formatting time:', error);
      return 'Invalid Time';
    }
  };

  const handleCancelAppointment = async (appointmentId) => {
    if (!window.confirm('Are you sure you want to cancel this appointment?')) {
      return;
    }

    try {
      setIsLoading(true);
      await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/Appointment/cancel-appointment/${appointmentId}`
      );

      setAppointments(appointments.map(appt =>
        appt.MAD_APPOINMENT_ID === appointmentId
          ? { ...appt, MAD_STATUS: "I" }
          : appt
      ));

      showSnackbar("Appointment cancelled successfully", "success");
    } catch (error) {
      console.error("Error cancelling appointment:", error);
      showSnackbar("Failed to cancel appointment", "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Box
          sx={{
            mb: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            color="primary"
            fontWeight={600}
            align="center"
          >
            Daily Appointments
          </Typography>

         
        
          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: 2,
              mb: 3,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <TextField
              type="date"
              label="Select Date"
              value={selectedDate}
              onChange={handleDateChange}
              InputLabelProps={{ shrink: true }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <DateRangeIcon sx={{ color: "primary.main" }} />
                  </InputAdornment>
                ),
              }}
              inputProps={{
                placeholder: "YYYY/MM/DD"
              }}
              sx={{
                minWidth: isMobile ? "100%" : 250,
                '& .MuiInputBase-input': {
                  position: 'relative',
                  backgroundColor: 'transparent',
                },
                '& input[type="date"]': {
                  color: 'transparent',
                  position: 'relative',
                  '&::-webkit-calendar-picker-indicator': {
                    opacity: 0,
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    width: '100%',
                    height: '100%',
                    cursor: 'pointer',
                    zIndex: 2,
                  },
                },
                '& .MuiInputBase-root': {
                  position: 'relative',
                  '&::after': {
                    content: selectedDate
                      ? `"${selectedDate.split('-').join('/')}"`
                      : '"YYYY/MM/DD"',
                    position: 'absolute',
                    left: '40px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: selectedDate ? 'rgba(0, 0, 0, 0.87)' : 'rgba(0, 0, 0, 0.6)',
                    fontSize: '14px',
                    fontFamily: 'inherit',
                    pointerEvents: 'none',
                    zIndex: 1,
                  }
                }
              }}
            />
          </Box>
        </Box>

        {isLoading && !selectedSlotId ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Paper elevation={3} sx={{ p: 3, textAlign: "center" }}>
            <Typography variant="h6" color="textSecondary">
              {error}
            </Typography>
          </Paper>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                gutterBottom
                color="primary"
                fontWeight={600}
              >
                Available Timeslots ({timeslots.length})
              </Typography>
              <Grid container spacing={2}>
                {timeslots.map((timeslot) => (
                  <Grid item xs={12} key={timeslot.MT_SLOT_ID}>
                    <Card
                      elevation={3}
                      sx={{
                        borderLeft:
                          selectedSlotId === timeslot.MT_SLOT_ID
                            ? `4px solid ${theme.palette.primary.main}`
                            : "none",
                        cursor: "pointer",
                        "&:hover": {
                          boxShadow: 4,
                        },
                      }}
                      onClick={() =>
                        handleViewAppointments(timeslot.MT_SLOT_ID)
                      }
                    >
                      <CardContent>
                        <Box
                          sx={{ display: "flex", alignItems: "center", mb: 1 }}
                        >
                          <Avatar
                            sx={{ bgcolor: theme.palette.primary.main, mr: 2 }}
                          >
                            <PersonIcon />
                          </Avatar>
                          <Typography variant="subtitle1">
                            {timeslot.MT_DOCTOR || 'Unknown Doctor'}
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <TimeIcon color="action" sx={{ mr: 1 }} />
                          <Typography>
                            {formatTime(timeslot.MT_START_TIME)} -{" "}
                            {formatTime(timeslot.MT_END_TIME)}
                          </Typography>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        )}

        {/* Responsive Appointments Modal */}
        <AppointmentsModal
          open={isModalOpen}
          onClose={handleCloseModal}
          appointments={appointments}
          searchTerm={searchTerm}
          onSearchChange={(e) => setSearchTerm(e.target.value)}
          isLoading={isLoading}
          onStatusUpdate={handleStatusUpdate}
          onAddRecord={handleAddRecord}
          onCancelAppointment={handleCancelAppointment}
          onPrintAppointment={handlePrintAppointment}
          selectedSlotId={selectedSlotId}
          onRefresh={handleRefreshAppointments}
        />

        {/* Universal Printing Dialog */}
        <UniversalPrintDialog
          open={universalPrintDialogOpen}
          onClose={() => setUniversalPrintDialogOpen(false)}
          appointment={selectedAppointment}
          onThermalPrint={handleThermalPrint}
        />

        {/* Thermal Printing Dialog with BMP Support */}
        <ThermalPrintDialog
          open={thermalPrintDialogOpen}
          onClose={() => setThermalPrintDialogOpen(false)}
          appointment={selectedAppointment}
        />

        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Paper>
    </Container>
  );
}